import React, { Component, createRef, Fragment } from 'react'
import axios from 'axios'
import { withRouter } from 'react-router'
import Toolbar from './../Toolbar/Toolbar'
import { Tooltip } from "@material-ui/core"
import Dropdown from 'react-dropdown';
import { withStyles } from "@material-ui/core/styles"
import 'react-dropdown/style.css';
import TableOfContents from './../TableOfContents/TableOfContents'
import _uniqueId from 'lodash/uniqueId';
import Directions from './../AttachmentsDisplay/Directions'
import AttachmentRenderer from './../AttachmentsDisplay/AttachmentRenderer'
import StepContent from './../StepContent/StepContent'
import StepActionsToolBar from './../StepActionsToolbar/StepActionsToolbar'
import ModelAnnotationContainter from "../../Author/ModelAnnotation/ModelAnnotation"
import EditStepNameFieldContainer from './../StepActionsToolbar/edit_step_name_field_container'
import PDFDisplay from "./../WiPDFViewer/pdfViewer"
import PublicationPageModal from './../PublicationPage/Modal'
import AttachmentsModal from './../Attachments/Modal'
import AddInfoFormModal from './../InfoPage/Modal'
import EditTagsModal from './../Tags/Modal'
import DoneButton from './ToggleButton'
import { imageExtensions, audioExtensions, videoExtensions, documentExtensions } from "../../../../Templates/data"
import { checkNotUndefindeNull, findExtension, isModel, replaceSpanWithTextInString, getRegexSelection } from "../../../../Templates/functions"
import { circleExclamation, AnnotationModelIcon, tocToggleIcon, dotsIcon, closeStepAlertsIcon, countStepAlerts, openStepAlertsIcon, addAttachmentIcon } from "../../../../Templates/icons"
import { cloneDeep, isEmpty, isEqual, mapKeys } from 'lodash'
import { fetchWorkInstruction, deleteModelAnnotation, deleteHighlight, createHighlight } from '../../../../../util/wi_util'
import { online } from '../../../../../util/user_util'
import { getFlatDataFromTree } from 'react-sortable-tree';
import StepAlerts from './../InfoPage/StepAlerts'
import EditTitleForm from './../Toolbar/edit_title_form_container'
import Highlighter from "react-highlight-words";
import temppdf from "./../WiPDFViewer/assets/160.76-EG1.pdf"
import WebViewer from '@pdftron/webviewer'
import EmbeddedWISelect from '../../Author/StepContent/EmbeddedWISelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'


// -------------------------------------------------------------- Tooltip Styles --------------------------------------------------------------//

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: "1em",
    },
}))(Tooltip);

// -------------------------------------------------------------- Component: WIAuthor --------------------------------------------------------------//

class WIAuthorSteps extends Component {
    constructor(props) {
        super(props)
        // Default isLiteView to false if not provided
        const isLiteView = props.isLiteView || false;
        this.state = {
            steps: props.workInstruction.steps || [],
            stepsDisplay: [],
            isSavable: true,
            title: "",
            WipGroup: [],
            tempPDF: temppdf,
            selectedStep: null,
            currentAttachments: [],
            attachmentIndex: 0,
            confirmationMessage: "",
            editingContent: false,
            editingPublicationPage: false,
            publicationPage: {},
            editingStepTitle: false,
            editingStepAlerts: false,
            editingtTags: false,
            showingAddInfoForm: false,
            showingAttachments: false,
            embeddedFile: undefined,
            toggleAnnotation: false,
            currentCameraPlacement: [],
            unityContextRef: null,
            selectedStepIsChild: false,
            editingTime: false,
            stepNodePath: [],
            // Show TOC only if not in Lite View
            showTOC: !isLiteView,
            selectedStepDivID: "",
            pathList: [],
            searchString: "",
            stepDivsSearchText: null,
            textSelectedInEditorFlag: false,
            textSelectedInEditor: "",
            annotations: null,
            selectedAnnotation: null,
            existingAnnotationClicked: false,
            AnnotationMode: "view",
            DeleteAnnotationActive: false,
            Pointer: "circle",
            AnnotationArray: [],
            AnnotationCount: 0,
            AnnotationText: "",
            modelsLoaded: false,
            AnnotationName: "",
            WebglAnnotationList: [],
            listSent: false,
            displayModelText: false,
            editorRef: null,
            toggleStepDropDown: false,
            isCurrentAttachmentTypeModel: false,
            modelIsLoaded: false,
            textSelectionRange: null,
            annotationHasBeenCreatedPre: false,
            currentStepAttachmentModel: false,
            displayArray: [],
            currentHighlightID: null,
            textToSearch: "",
            currentPDF: null,
            selectedText: "",
            annoList: [],
            PDFAnnotations: null,
            pageNumber: 1,
            currentlySelectedPDFAnnotationID: [],
            currentlySelectedPDFAnnotationAttachment: [],
            isRedraw: false,
            combinedTitle: [],
            addingPDFPageWILink: false,
            firstLoaded: false,
            isLibraryOpen: false,
            isLibraryClosing: false,
            doneStepList: [],
            modalToDisplay: null,
            pendingAnnotationId: null,
            previewImages: props.workInstruction.previewImages || [],
            showEditingWarningModal: false,
            editingWarningMessage: '',
            editingWarningUser: '',
        }
        // Refs should be instance properties, not in state
        this.viewerDiv = createRef(null);
        this.searchInputRef = createRef(null);
        this.handleModalOpen = this.handleModalOpen.bind(this)
    }

    handleModelsLoaded = (loaded) => {
        this.setState({ modelsLoaded: loaded }, () => {
            if (this.state.modelsLoaded && this.state.pendingAnnotationId) {
                this.sendAnnotationToThreeJS(this.state.pendingAnnotationId);
                this.setState({ pendingAnnotationId: null });
            }
        });
    };

    componentDidMount = async () => {
        console.log(`[WI ${this.props.wip_ID}] Component mounted`, {
            isLiteView: this.props.isLiteView,
            stackTrace: new Error().stack
        });
        let stepDivParent = document.getElementById("step-Div-Parent")
        console.log(this.props)
        
        // Start heartbeat system for editing awareness
        this.startHeartbeat();
        
        fetchWorkInstruction(this.props.wip_ID, !this.props.isLiteView).then(
            res => {
                localStorage.removeItem('persist:wi_author')
                let wi = cloneDeep(res.data)

                
                // Check if someone else is currently editing
                this.checkAndShowEditingWarning(wi.editingStatus);
                
                let firstStep = wi.steps[0]
                // console.log("firstStep", firstStep)
                //If the work instruction has info items, it will populate currentStepInfoItems with Objects containing keys of categories and a value of items in category. 
                let infoPage = typeof wi.info_page === "string" ? JSON.parse(wi.info_page) : wi.info_page
                let isModel = this.isAttachmentModel(firstStep, 0)
                let currentStepInfoItems = this.buildInfoItems(infoPage, firstStep._id)
                let stepsDoneList = []
                if (this.props.isLiteView && this.props.user) {
                    const assign = this.props.user.assignments?.find(a => a.WIPID === this.props.wip_ID);
                    const baseList = this.createDoneStepStateList(wi.steps);
                    if (assign && Array.isArray(assign.stepsDone) && assign.stepsDone.length > 0) {
                        const doneMap = new Map(assign.stepsDone.map(d => [d._id, !!d.done]));
                        stepsDoneList = baseList.map(item => ({ ...item, done: doneMap.has(item._id) ? doneMap.get(item._id) : item.done }));
                        console.log('[WIAuthorSteps] Init from backend stepsDone:', { assignWIP: assign.WIPID, count: assign.stepsDone.length });
                    } else {
                        stepsDoneList = baseList;
                        console.log('[WIAuthorSteps] No backend stepsDone found; using defaults');
                    }
                }

                this.setState({
                    currentStepInfoItems,
                    currentAttachments: this.SetAttachmentsBasedOnWipPDF(wi.isPDFViewer, firstStep, wi.PDFViewerHighlights),
                    infoPage: infoPage || {},
                    isReleased: wi.release,
                    previewImage: wi.preview_img || "default-wi-preview-img.jpg",
                    publicationPage: wi.publication_page || {},
                    selectedStep: firstStep,
                    steps: wi.steps,
                    path: firstStep ? [firstStep._id] : [],
                    tags: wi.tags,
                    WipGroup: wi.WipGroup,
                    title: wi.title,
                    previewImages: wi.previewImages || [],
                    isPDFViewer: wi.isPDFViewer,
                    pdfPath: wi.pdfPath,
                    PDFViewerHighlights: wi.PDFViewerHighlights,
                    originalTitle: wi.title,
                    require_info_checks: wi.require_info_checks,
                    workInstruction: wi,
                    stepDivsSearchText: typeof stepDivParent != "undefined" && stepDivParent != null ? stepDivParent.innerText : "No Text",
                    selectedStepDivID: "div_step_" + firstStep._id,
                    currentStepAttachmentModel: isModel,
                    doneStepList: stepsDoneList
                }, () => {
                    this.setState({ loaded: true })
                    console.log('[WIAuthorSteps] Post-init doneStepList sample:', this.state.doneStepList.slice(0, 5));

                    // Load saved progress (Electron offline file)
                    this.loadProgress();

                    // this.getSetWipPDF()
                        this.updateContentSpan()
                        this.createStepsDisplay()
                        this.createAnnotationArray()


                })
                    var pageListener = document.getElementById("wi-author-page")
                    { pageListener ? pageListener.addEventListener("click", this.handleClicks) : console.log("unable to add listener to wi author") }
                    this.setEventListener();
                    this.setUnityCameraEventListener();
            }).catch((err) => {
                alert("An error occured while trying to open this WI. Please contact an administrator for assisstance.")
                console.error(err)
            })
    }
    // -------------------------------------------------------------- Component Lifecycle: componentDidUpdate --------------------------------------------------------------//

    componentDidUpdate(prevProps, prevState) {
        // Prevent stealing focus from search input when user is typing
        const isSearchInputFocused = document.activeElement?.id === `stepDivSearch_${this.props.wip_ID}` || 
                                     document.activeElement === this.searchInputRef.current;
        
        // Debug: Log what changed that triggered this update
        if (prevState.searchString !== this.state.searchString) {
            console.log(`[WI ${this.props.wip_ID}] componentDidUpdate triggered by searchString change, activeElement:`, document.activeElement?.id);
        }
        if (prevState.stepsDisplay !== this.state.stepsDisplay) {
            console.log(`[WI ${this.props.wip_ID}] componentDidUpdate triggered by stepsDisplay change, activeElement:`, document.activeElement?.id);
            // Capture focus state BEFORE doing anything that might steal focus
            const inputId = `stepDivSearch_${this.props.wip_ID}`;
            const shouldPreserveFocus = isSearchInputFocused || document.activeElement?.id === inputId;
            const inputValue = shouldPreserveFocus ? (this.searchInputRef.current?.value || document.getElementById(inputId)?.value || '') : '';
            const cursorPos = shouldPreserveFocus ? (this.searchInputRef.current?.selectionStart || document.getElementById(inputId)?.selectionStart || inputValue.length) : 0;
            
            // When stepsDisplay changes, attach event listeners to newly rendered WI links
            // Use setTimeout to ensure DOM is updated, but preserve focus if user was typing
            setTimeout(() => {
                this.updateContentSpan();
                
                // Restore focus to search input if user was typing when this update happened
                if (shouldPreserveFocus) {
                    requestAnimationFrame(() => {
                        const input = this.searchInputRef.current || document.getElementById(inputId);
                        if (input && document.activeElement !== input) {
                            console.log(`[WI ${this.props.wip_ID}] Restoring focus after stepsDisplay update, value: "${input.value}", cursorPos: ${cursorPos}`);
                            input.focus();
                            // Restore cursor position
                            if (input.setSelectionRange && input.value.length > 0) {
                                const newCursorPos = Math.min(cursorPos, input.value.length);
                                input.setSelectionRange(newCursorPos, newCursorPos);
                            }
                        }
                    });
                }
            }, 0);
        }
        
        // Fix: Compare with prevState, not prevProps!
        if (!isEqual(this.state.selectedStep, prevState.selectedStep)) {
            console.log(`[WI ${this.props.wip_ID}] componentDidUpdate: selectedStep changed, isSearchInputFocused: ${isSearchInputFocused}`);
            if (checkNotUndefindeNull(this.state.unityContextRef)) { this.setUnityCameraEventListener(); }

            // Only focus on step div if search input is NOT focused (user is not typing)
            // But don't focus if user just clicked on a WI link or other interactive element
            const clickedElement = document.activeElement;
            const isClickingInteractiveElement = clickedElement?.tagName === 'SPAN' && 
                                                  (clickedElement?.classList.contains('WIClickable') || 
                                                   clickedElement?.classList.contains('spansClick'));
            
            if (this.state.selectedStep != null && !isSearchInputFocused && !isClickingInteractiveElement) {
                let el = document.getElementById("div_step_" + this.state.selectedStep._id)
                if (el != null) {
                    console.log(`[WI ${this.props.wip_ID}] Focusing step div: div_step_${this.state.selectedStep._id}`);
                    el.focus();
                }
            } else if (this.state.selectedStep != null && (isSearchInputFocused || isClickingInteractiveElement)) {
                console.log(`[WI ${this.props.wip_ID}] Skipping step div focus - search input focused: ${isSearchInputFocused}, clicking interactive: ${isClickingInteractiveElement}`);
            }
            // Always call updateContentSpan to attach event listeners, even if we skipped focus
            this.updateContentSpan();
        }
        
        // Auto-save when content editor is closed (editingContent: true -> false)
        if (prevState.editingContent && !this.state.editingContent) {
            if (this.state.isSavable) {
                this.saveWorkInstruction();
            }
        }
        
        const userJustArrived = this.props.user && !prevProps.user;
        const stepsJustArrived = this.state.steps.length > 0 && prevState.steps.length === 0;
        // Removed default reset when user or steps arrive to avoid clobbering backend-provided done states

        // Additional check: if the assignments array for this WIP shows up or its stepsDone length changes, refresh the list
        if (this.props.isLiteView && this.props.user) {
            const prevAssign = prevProps.user?.assignments?.find(a => a.WIPID === this.props.wip_ID);
            const currAssign = this.props.user.assignments?.find(a => a.WIPID === this.props.wip_ID);
            if (currAssign) {
                const prevStepsDone = prevAssign?.stepsDone || [];
                const currStepsDone = currAssign.stepsDone || [];
                if (!isEqual(prevStepsDone, currStepsDone)) {
                    const baseList = this.createDoneStepStateList(this.state.steps);
                    const doneMap = new Map(currStepsDone.map(d => [d._id, !!d.done]));
                    const refreshedList = baseList.map(item => ({ ...item, done: doneMap.has(item._id) ? doneMap.get(item._id) : item.done }));
                    if (!isEqual(refreshedList, this.state.doneStepList)) {
                        console.log('[WIAuthorSteps] Synced doneStepList from backend assignments', { count: currStepsDone.length });
                        this.setState({ doneStepList: refreshedList }, () => this.createStepsDisplay());
                    }
                }
            }
        }
    }
    // -------------------------------------------------------------- Component Lifecycle: componentWillUnmount --------------------------------------------------------------//

    componentWillUnmount = () => {
        console.log(`[WI ${this.props.wip_ID}] Component unmounting, removing event listeners`, {
            stackTrace: new Error().stack
        });
        try {
        } catch (e) {}
        this.unsetEventListener();
        this.stopHeartbeat();
    }
    
    // -------------------------------------------------------------- Heartbeat System for Editing Awareness --------------------------------------------------------------//
    
    startHeartbeat = () => {
        if (this.props.isLiteView) {
            return;
        }
        // Send heartbeat every 30 seconds to indicate this user is actively editing
        this.heartbeatInterval = setInterval(() => {
            if (this.props.wip_ID) {
                axios.post(`/api/wip/${this.props.wip_ID}/heartbeat`)
                    .catch((error) => {
                        console.error(`[WI ${this.props.wip_ID}] Heartbeat failed:`, error.response?.status, error.response?.data);
                    });
            }
        }, 10000); // 10 seconds for testing (change back to 30000 for production)
        

    }
    
    stopHeartbeat = () => {
        if (this.props.isLiteView) {
            return;
        }
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;

        }
        
        // Signal that this user is no longer editing
        if (this.props.wip_ID) {
            axios.post(`/api/wip/${this.props.wip_ID}/stop-editing`)
                .catch((error) => {
                    console.log('Stop editing signal failed:', error);
                    // Don't show error to user
                });
        }
    }
    
    // -------------------------------------------------------------- Editing Status Warning System --------------------------------------------------------------//
    
    checkAndShowEditingWarning = (editingStatus) => {
        // Skip editing warning for Lite views (read-only/nested WIs)
        if (this.props.isLiteView) {
            return;
        }
        
        if (editingStatus && editingStatus.isActivelyEditing && editingStatus.editing_user !== this.props.user?.username) {
            const secondsSinceStarted = editingStatus.secondsSinceStartedEditing || 0;
            const timeEditing = secondsSinceStarted < 60 ? 
                `${secondsSinceStarted} seconds` : 
                `${Math.floor(secondsSinceStarted / 60)} minutes`;
                
            this.setState({
                showEditingWarningModal: true,
                editingWarningMessage: `"${editingStatus.editing_user}" has been editing this Work Instruction for ${timeEditing}. Editing simultaneously may cause conflicts and data loss.`,
                editingWarningUser: editingStatus.editing_user
            });
        }
    }
    
    handleReturnToList = () => {
        // Navigate back to the WI list
        this.props.history.push('/dashboard/work%20instructions%20parent');
    }
    
    handleContinueEditing = () => {
        // Close the modal and continue with editing
        this.setState({
            showEditingWarningModal: false,
            editingWarningMessage: '',
            editingWarningUser: ''
        });
    }
    
    // -------------------------------------------------------------- Update content spans in the document --------------------------------------------------------------//

    updateContentSpan = () => {

        let spans = document.getElementsByClassName("spansClick");
        let imgs = document.getElementsByClassName("closeImgWI");
        let ma = document.getElementsByClassName("closeImgMA");
        let wh = this.props.isLiteView ? "0" : "10px"
        let closeout = <span style={{ zIndex: "100", display: "inline-block", width: wh, height: wh }} ><svg className="clickable" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />
        </svg></span>
        Array.from(spans).forEach((s) => {
            if (s.classList.contains("NCL")) {
                s.addEventListener("click", this.showAnnotationJS);
                s.classList.remove("NCL");
                s.classList.add("CL")
            }
            if (s.classList.contains("WIL")) {
                s.addEventListener("click", this.showWI);
                s.classList.remove("WIL");
                s.classList.add("WL")

            }
        })
        Array.from(imgs).forEach((i) => {
            if (!this.props.isLiteView) {
                i.addEventListener("click", this.deleteWI)
            }
        })
        Array.from(ma).forEach((i) => {
            if (!this.props.isLiteView) {
                i.addEventListener("click", this.deleteMA)
            }
        })
    }
    // -------------------------------------------------------------- Set Attachments Based on Work Instruction PDF --------------------------------------------------------------//
    //TODO: Maybe remove this function
    SetAttachmentsBasedOnWipPDF = (isPDFViewer, firstStep, PDFViewerHighlights) => {
        if (isPDFViewer) {
            return []
        }
        if (firstStep) {
            return firstStep.attachments
        }
        return []
    }
  
    // -------------------------------------------------------------- Create done step state --------------------------------------------------------------//

    createDoneStepStateList = (steps) => {
        const list = [];
        const build = (step)=>{
            list.push({_id:step._id, done:false});
            if(step.children&&step.children.length>0){step.children.forEach(build);} }
        steps.forEach(build);
        console.log('[WIAuthorSteps] createDoneStepStateList generated:', { count: list.length });
        return list;
    }

    updateDoneStepStateList = (stepId, done)=>{
        console.log('[WIAuthorSteps] updateDoneStepStateList called:', { stepId, done });
        let list = this.state.doneStepList
        let s = list.find(s => s._id === stepId)
        if (!s) {
            console.warn(`[WIAuthorSteps] stepId ${stepId} not found in list – regenerating doneStepList.`);
            list = this.createDoneStepStateList(this.state.steps);
            this.setState({ doneStepList: list });
            s = list.find(item => item._id === stepId);
            if (!s) {
                console.error(`[WIAuthorSteps] Regenerated list still missing stepId ${stepId}. Aborting update.`);
                return;
            }
        }
        s.done = done
        console.log('[WIAuthorSteps] Updated doneStepList (sample):', list.slice(0, 5));
        this.setState({doneStepList: list}, async ()=>{
            // Rebuild display so Done buttons get fresh props
            this.createStepsDisplay();
            // Persist locally via Electron backend
            try {
                const isElectron = typeof window !== 'undefined' && !!window.electronAPI;
                if (isElectron) {
                    const base = window.config ? window.config.getApiBaseUrl() : '';
                    await fetch(`${base}/api/stepsProgress/${this.props.wip_ID}`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(this.state.doneStepList)
                    });
                    console.log('[WIAuthorSteps] Saved to Electron local progress');
                }
            } catch (e) {
                console.error('[WIAuthorSteps] Failed to save step progress:', e);
            }

            // Also persist to SQL backend (only if user has an assignment for this WIP)
            try {
                if (this.props.user && this.props.updateUserStepsDone) {
                    const assign = this.props.user.assignments?.find(a => a.WIPID === this.props.wip_ID);
                    if (assign) {
                        console.log('[WIAuthorSteps] Persisting to backend_SQL /stepsDone');
                        const payload = {
                            updates: { assignments: [{ WIPID: this.props.wip_ID, stepsDone: list }] },
                            userID: this.props.user._id,
                            wip_ID: this.props.wip_ID,
                        };
                        await this.props.updateUserStepsDone(payload);
                    } else {
                        console.warn('[WIAuthorSteps] Skipping SQL persist: user has no assignment for this WIP.');
                    }
                }
            } catch (e) {
                console.error('[WIAuthorSteps] Failed to persist stepsDone to backend_SQL:', e);
            }
        })
    }
    // -------------------------------------------------------------- Add wi link to WipGroup --------------------------------------------------------------//
    addWILink = (wi) => {
        let WipGroup = cloneDeep(this.state.WipGroup)
        WipGroup.push(wi)
        this.setState({ WipGroup }, () => {
            this.saveWorkInstruction();
        })
    }
    // -------------------------------------------------------------- remove wi link to WipGroup --------------------------------------------------------------//

    deleteWILink = (wi) => {
        console.log('[WIAuthorSteps - deleteWILink] Starting WI link deletion process')
        console.log('[WIAuthorSteps - deleteWILink] WI object:', wi)
        console.log('[WIAuthorSteps - deleteWILink] Current WipGroup before deletion:', cloneDeep(this.state.WipGroup))
        
        this.removeWILinkHighlight(wi.wiID)
        let WipGroup = cloneDeep(this.state.WipGroup)
        for (let w in WipGroup) {
            if (WipGroup[w].wip_ID == wi.wiID) {
                console.log('[WIAuthorSteps - deleteWILink] Marking WI as deleted:', WipGroup[w])
                WipGroup[w].del = true
            }
        }
        console.log('[WIAuthorSteps - deleteWILink] WipGroup after marking as deleted:', WipGroup)
        
        //let WipGroup = Wg.filter(w=> w.wip_ID !== wi.wiID)   
        this.setState({ WipGroup }, () => {
            console.log('[WIAuthorSteps - deleteWILink] State updated, calling saveWorkInstruction')
            this.saveWorkInstruction();
        })
    }

    // -------------------------------------------------------------- will remoce the WI highlioght from the text --------------------------------------------------------------//

    removeWILinkHighlight = (wi) => {
        console.log('[WIAuthorSteps - removeWILinkHighlight] Starting WI link highlight removal')
        console.log('[WIAuthorSteps - removeWILinkHighlight] WI ID to remove:', wi)
        console.log('[WIAuthorSteps - removeWILinkHighlight] Current selectedStep:', this.state.selectedStep)
        
        // Search all steps, not just the selected one, because the WI link might be in any step
        let allSteps = this.state.workInstruction.steps || []
        console.log('[WIAuthorSteps - removeWILinkHighlight] Searching through all steps:', allSteps.length)
        
        let regExpWI = new RegExp('\\&lt;WI,(.*?),(.*?),(.*?).&gt;', 'g')
        let foundInStep = null
        
        // Search through all steps for the WI link
        for (let stepIndex = 0; stepIndex < allSteps.length; stepIndex++) {
            let step = allSteps[stepIndex]
            let content = step.content || ''
            console.log(`[WIAuthorSteps - removeWILinkHighlight] Checking step ${stepIndex + 1} (${step._id}):`, content)
            
            let matchesWI = [...content.matchAll(regExpWI)]
            console.log(`[WIAuthorSteps - removeWILinkHighlight] Found WI matches in step ${stepIndex + 1}:`, matchesWI)
            
            if (matchesWI.length > 0) {
                for (let i = 0; i < matchesWI.length; i++) {
                    console.log('[WIAuthorSteps - removeWILinkHighlight] Checking WI match:', matchesWI[i])
                    if (matchesWI[i][2] === wi) {
                        console.log('[WIAuthorSteps - removeWILinkHighlight] Found matching WI to remove in step:', step._id)
                        foundInStep = step
                        
                        let newContent = content.replace(matchesWI[i][0], "")
                        console.log('[WIAuthorSteps - removeWILinkHighlight] New content after removal:', newContent)
                        
                        step.content = newContent
                        let steps = this.updateStep(step)
                        this.updateSteps(steps, step);
                        this.createStepsDisplay();
                        console.log('[WIAuthorSteps - removeWILinkHighlight] Step content updated and display refreshed')
                        return // Exit once we find and remove the WI link
                    }
                }
            }
        }
        
        if (!foundInStep) {
            console.log('[WIAuthorSteps - removeWILinkHighlight] No WI link matches found in any step')
        }
    }

    handleClicks = (event) => {
        var page = document.getElementById("wi-author-page")
        var timeEsti = document.getElementById("edit-step-estimation-form")
        if (page && timeEsti) {
            if (!event.path.find(({ id }) => id === "edit-step-estimation-form")) {
                this.toggleEditingTime(false)
            }
        }
    }

    checkIfAttachmentHasAnnotationArray = () => {
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        if (checkNotUndefindeNull(selectedStepClone)) {
            let attachments = selectedStepClone.attachments
            const currentAttachment = attachments[this.state.attachmentIndex || 0]

            if (attachments.length > 0 && typeof currentAttachment.annotations != "undefined" && currentAttachment.annotations != null && currentAttachment.annotations.length > 0) {
                console.log(typeof currentAttachment.annotations)
                // currentAttachment.annotations = [];
                attachments[this.state.attachmentIndex || 0] = currentAttachment
                selectedStepClone.attachments = attachments
                let steps = this.updateStep(selectedStepClone)
                this.updateSteps(steps, selectedStepClone);
            }
        }
    }
    // -------------------------------------------------------------- Set Unity Camera Event Listener --------------------------------------------------------------//

    setUnityCameraEventListener = () => {
        if (this.state.unityContextRef != null) {
            this.state.unityContextRef.on("modelsLoaded", () => {
                this.setState({ modelsLoaded: true });
                this.sendlist()
            })
            this.state.unityContextRef.on("storeCameraData", (cameraData) => {
                let pasredCameraData = JSON.parse(cameraData);
                let SelectedAnnotationClone = cloneDeep(this.state.selectedAnnotation);
                if (SelectedAnnotationClone != null) {
                    let state = JSON.parse(SelectedAnnotationClone.state)
                    SelectedAnnotationClone.camera_position = this.convertCameraData(pasredCameraData.position);
                    SelectedAnnotationClone.camera_rotation = this.convertCameraData(pasredCameraData.rotation);//orgCameraData
                    state.orgCameraData = cameraData
                    SelectedAnnotationClone.state = JSON.stringify(state)
                    this.setState({ selectedAnnotation: SelectedAnnotationClone });
                }
            });
            this.state.unityContextRef.on("storeClickedAnnotation", (AnnotationData) => {
            })
            this.state.unityContextRef.on("storeCreatedAnnotation", (AnnotationData) => {
                this.addAnnotation(AnnotationData);
            })
            this.state.unityContextRef.on("storeDeletedAnnotation", (AnnotationData) => {
                let data = JSON.parse(AnnotationData)
                this.deleteAnnotationFromWebgl(data.id)
            })
        }
    }
    // -------------------------------------------------------------- Converts camera data into a string representation. --------------------------------------------------------------//

    convertCameraData = (data) => {
        let cameraDataString = data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
        return cameraDataString
    }


    // -------------------------------------------------------------- Converts rotation data into a string representation. --------------------------------------------------------------//

    convertRotationData = (data) => {
        let cameraDataString = data.w.toString() + ", " + data.x.toString() + ", " + data.y.toString() + ", " + data.z.toString()
        return cameraDataString
    }
    // -------------------------------------------------------------- Unsets an event listener and updates the element's position if needed. --------------------------------------------------------------//

    unsetEventListener = () => {
        let display = document.getElementById("webGL-window")
        { display ? display.removeEventListener("click", this.updateCamerandMousePosition) : console.log("Unable to unset click listener for webgl") }
        { display ? display.style.removeProperty("position") : console.log("Unable to remove positon to absolute for webgl") }
        if (this.state.unityContextRef != null) {
        }
    }
    // -------------------------------------------------------------- Sets an event listener and updates the element's position if needed. --------------------------------------------------------------//

    setEventListener = () => {
        let display = document.getElementById("webGL-window")
        { display ? display.addEventListener("click", this.updateCamerandMousePosition) : console.log("Unable to set click listener for webgl") }
        { display ? display.style.setProperty("position", "absolute") : console.log("Unable to set positon to absolute for webgl") }
    }
    // -------------------------------------------------------------- Sets the selected annotation, updates the state, and sends data to the model viewer. --------------------------------------------------------------//

    setSelectedAnnotation = (annotation, id) => {
        this.removeSelectedAnnotationClass();
        let newSelectedDiv = document.getElementById(id)
        if (typeof newSelectedDiv != "undefined" && newSelectedDiv != null) {
            newSelectedDiv.classList.add("selectedAnnotation")
        }
        let state = JSON.parse(annotation.state)
        this.setState(
            {
                AnnotationMode: "view",
                selectedAnnotation: annotation,
                DeleteAnnotationActive: true,
                Pointer: annotation.pointer,
                AnnotationText: annotation.message || "", AnnotationName: state.name,
                existingAnnotationClicked: true
            })
        this.sendAnnotationToWebgl(annotation.Anno_id)
        this.clickOnAnnotation(annotation.Anno_id);
    }
    // -------------------------------------------------------------- Sends an annotation to the WebGL viewer. --------------------------------------------------------------//

    sendAnnotationToWebgl = (id) => {
        console.log(id);
        if (checkNotUndefindeNull(this.state.unityContextRef)) {
            this.state.unityContextRef.send("Manager", "ShowAnnotation", (id))
            this.state.unityContextRef.send("Manager", "LookAtAnnotation", (id))
        }
    }
    // -------------------------------------------------------------- Creates a new annotation. --------------------------------------------------------------//

    createAnnotation = (highLightedText) => {
        if (this.state.isLibraryOpen) {
            return;
        }
        let randString = this.makeid(15)
        let id = _uniqueId(`${randString}-`)
        let name = highLightedText
        let displayWidth = document.getElementById("webGL-window").clientWidth;
        let displayHeight = document.getElementById("webGL-window").clientHeight;
        let NewAnnotation = {
            Anno_id: id,
            background_color: "#ffffff",
            state: JSON.stringify({ name: name, canvasWidth: displayWidth, canvasHeight: displayHeight, orgCameraData: {} }),
            message: highLightedText ? highLightedText : "",
            camera_position: "",
            camera_rotation: "",
            x: 0,
            y: 0,
            pointer: "circle"
        }
        this.removeSelectedAnnotationClass();
        this.setState({ AnnotationMode: "new", selectedAnnotation: NewAnnotation, Pointer: "circle", AnnotationText: "", AnnotationName: name, existingAnnotationClicked: false });

    }
    // -------------------------------------------------------------- Adds an annotation. --------------------------------------------------------------//
    //edited stepID and highlightID
    addAnnotation = (data) => {
        if (this.state.isLibraryOpen) {
            return;
        }
        let webGLWindow = document.getElementById("webGL-window");
        let anno_array = cloneDeep(this.state.AnnotationArray);
        let name = this.state.textSelectedInEditor;
        let displayWidth = webGLWindow.clientWidth;
        let displayHeight = webGLWindow.clientHeight;
        let parsedData = JSON.parse(data)
        let newAnnotation = {
            wipID: this.state.workInstruction._id,
            StepID: this.state.selectedStep._id,
            HighlightID: null,
            AttachmentID: this.state.currentAttachments[this.state.attachmentIndex]._id,
            Anno_id: parsedData.id,
            background_color: "#ffffff",
            state: JSON.stringify({ name: name, canvasWidth: displayWidth, positon: this.convertCameraData(parsedData.position), canvasHeight: displayHeight, orgCameraData: data, scale: parsedData.scale }),
            message: this.state.textSelectedInEditor,
            camera_position: this.convertCameraData(parsedData.cameraPosition),
            camera_rotation: this.convertRotationData(parsedData.cameraRotation),
            x: 0,
            y: 0,
            pointer: "circle"
        }
        this.setState({
            AnnotationMode: "new",
            selectedAnnotation: newAnnotation,
            Pointer: "circle",
            AnnotationText: parsedData.text,
            AnnotationName: name,
            existingAnnotationClicked: false,
            annotationHasBeenCreatedPre: true
        });
    }


    // -------------------------------------------------------------- Handles clicking on an annotation. --------------------------------------------------------------//

    clickOnAnnotation = (id) => {
        if (this.state.isLibraryOpen) {
            return;
        }
        if (!this.state.listSent) {
            this.sendlist();
            this.setState({ listSent: true })
            setTimeout(() => {
                if (checkNotUndefindeNull(this.state.unityContextRef)) {
                    this.state.unityContextRef.send("Manager", "ShowAnnotation", id)
                    this.state.unityContextRef.send("Manager", "LookAtAnnotation", id)
                }
            }, 100)
        }
        else {
            if (checkNotUndefindeNull(this.state.unityContextRef)) {
                this.state.unityContextRef.send("Manager", "ShowAnnotation", id)
                this.state.unityContextRef.send("Manager", "LookAtAnnotation", id)
            }
        }
    }


    sendAnnotationToThreeJS = (annotationID) => {
        console.log('[sendAnnotationToThreeJS] Looking for annotation ID:', annotationID);
        console.log('[sendAnnotationToThreeJS] WebglAnnotationList:', this.state.WebglAnnotationList);
        
        // Try matching by id or Anno_id (adjust depending on your data)
        let annotationData = this.state.WebglAnnotationList.find(data =>
            data.id === annotationID || data.Anno_id === annotationID
        );
        
        // If not found in WebglAnnotationList, try to find it directly in the current step's attachments
        if (!annotationData && this.state.selectedStep) {
            console.log('[sendAnnotationToThreeJS] Not found in WebglAnnotationList, searching attachments...');
            const attachments = this.state.selectedStep.attachments || [];
            const currentAttachment = attachments[this.state.attachmentIndex || 0];
            console.log('[sendAnnotationToThreeJS] Current attachment:', currentAttachment);
            console.log('[sendAnnotationToThreeJS] Current attachment annotations:', currentAttachment?.annotations);
            
            if (currentAttachment && currentAttachment.annotations) {
                console.log('[sendAnnotationToThreeJS] All annotations in attachment:', currentAttachment.annotations);
                console.log('[sendAnnotationToThreeJS] Searching for Anno_id:', annotationID);
                currentAttachment.annotations.forEach((a, idx) => {
                    console.log(`[sendAnnotationToThreeJS] Annotation ${idx} Anno_id:`, a.Anno_id, 'matches:', a.Anno_id === annotationID);
                });
                const annotation = currentAttachment.annotations.find(a => a.Anno_id === annotationID);
                console.log('[sendAnnotationToThreeJS] Found annotation:', annotation);
                
                if (annotation && annotation.state) {
                    try {
                        const state = JSON.parse(annotation.state);
                        console.log('[sendAnnotationToThreeJS] Parsed state:', state);
                        console.log('[sendAnnotationToThreeJS] orgCameraData:', state.orgCameraData);
                        
                        if (state.orgCameraData) {
                            annotationData = JSON.parse(state.orgCameraData);
                            console.log('[sendAnnotationToThreeJS] Parsed annotationData:', annotationData);
                        } else {
                            console.warn('[sendAnnotationToThreeJS] No orgCameraData in state!');
                        }
                    } catch (e) {
                        console.error('[sendAnnotationToThreeJS] Failed to parse annotation state or orgCameraData:', e);
                        console.error('[sendAnnotationToThreeJS] annotation.state:', annotation.state);
                    }
                } else {
                    console.warn('[sendAnnotationToThreeJS] Annotation found but no state field');
                }
            } else {
                console.warn('[sendAnnotationToThreeJS] No current attachment or annotations array');
            }
        }
        
        // Last resort: if annotation ID doesn't match any stored annotations, 
        // try to auto-fix if there's only one annotation in the attachment
        if (!annotationData && this.state.selectedStep) {
            const attachments = this.state.selectedStep.attachments || [];
            const currentAttachment = attachments[this.state.attachmentIndex || 0];
            
            if (currentAttachment && currentAttachment.annotations && currentAttachment.annotations.length > 0) {
                console.error('[sendAnnotationToThreeJS] BROKEN ANNOTATION LINK DETECTED!');
                console.error('[sendAnnotationToThreeJS] Link points to:', annotationID);
                console.error('[sendAnnotationToThreeJS] But attachment has:', currentAttachment.annotations.map(a => a.Anno_id));
                
                // If there's only one annotation in the attachment, assume that's the one the user meant
                if (currentAttachment.annotations.length === 1) {
                    const correctAnnotation = currentAttachment.annotations[0];
                    console.warn('[sendAnnotationToThreeJS] Auto-fixing: Using the only annotation available');
                    
                    if (correctAnnotation.state) {
                        try {
                            const state = JSON.parse(correctAnnotation.state);
                            if (state.orgCameraData) {
                                annotationData = JSON.parse(state.orgCameraData);
                                console.log('[sendAnnotationToThreeJS] Successfully recovered annotation data:', annotationData);
                                
                                // Auto-fix the step content with correct annotation ID
                                this.fixBrokenAnnotationLink(annotationID, correctAnnotation.Anno_id);
                            }
                        } catch (e) {
                            console.error('[sendAnnotationToThreeJS] Failed to parse recovered annotation:', e);
                        }
                    }
                }
            }
        }
        
        console.log("Sending annotation data to three.js:", annotationData);
        // Dispatch custom event with full annotation data if found
        const event = new CustomEvent("annotationSelected", {
            detail: annotationData ? { annotationData } : { annotationID }
        });
        document.dispatchEvent(event);
    }
    
    // Fixes broken annotation links by replacing old annotation ID with correct one
    fixBrokenAnnotationLink = (oldAnnotationID, newAnnotationID) => {
        console.log(`[fixBrokenAnnotationLink] Replacing ${oldAnnotationID} with ${newAnnotationID}`);
        
        // Find all steps that might contain the broken link
        const allSteps = this.state.steps || [];
        let fixed = false;
        
        const fixStepContent = (step) => {
            if (!step.content) return false;
            
            const regex = new RegExp(`<Annotation,${oldAnnotationID},`, 'g');
            if (regex.test(step.content)) {
                console.log(`[fixBrokenAnnotationLink] Found broken link in step ${step._id}`);
                step.content = step.content.replace(
                    new RegExp(`<Annotation,${oldAnnotationID},`, 'g'),
                    `<Annotation,${newAnnotationID},`
                );
                return true;
            }
            return false;
        };
        
        const processSteps = (steps) => {
            steps.forEach(step => {
                if (fixStepContent(step)) {
                    fixed = true;
                }
                if (step.children && step.children.length > 0) {
                    processSteps(step.children);
                }
            });
        };
        
        processSteps(allSteps);
        
        if (fixed) {
            console.log('[fixBrokenAnnotationLink] Fixed broken annotation link, saving...');
            this.setState({ steps: allSteps, isSavable: true }, () => {
                this.saveWorkInstruction();
                this.createStepsDisplay();
            });
        }
    }
    
    showAnnotationJS = (event) => {
        event.stopPropagation();
        const annotationID = event.target.id.split("~~~")[0];
        const attachmentIndex = parseInt(event.target.id.split("~~~")[1], 10);
    
        const stepElement = event.target.closest('.step-display-div');
        if (!stepElement) return;
    
        const stepId = stepElement.id.replace('div_step_', '');
    
        if (stepId === this.state.selectedStep._id && attachmentIndex === this.state.attachmentIndex) {
            // Ensure annotation array is up to date before sending
            this.createAnnotationArray();
            // Use setTimeout to ensure state is updated before sending
            setTimeout(() => {
                this.sendAnnotationToThreeJS(annotationID);
            }, 0);
            return;
        }
    
        if (stepId === this.state.selectedStep._id) {
            this.setState({
                attachmentIndex,
                pendingAnnotationId: annotationID
            }, () => {
                this.createAnnotationArray();
                // Send annotation after array is created
                setTimeout(() => {
                    this.sendAnnotationToThreeJS(annotationID);
                    this.setState({ pendingAnnotationId: null });
                }, 0);
            });
        } else {
            const found = this.findStepAndPathById(this.state.steps, stepId);
            if (found) {
                const { step, path } = found;
                this.setState({ pendingAnnotationId: annotationID }, () => {
                    this.selectStep(step, path, true, attachmentIndex);
                });
            }
        }
    }



    // -------------------------------------------------------------- Saves a new or edited annotation. --------------------------------------------------------------//

    saveNewAnnotation = () => {
        if (this.state.isLibraryOpen) {
            return;
        }
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        if (this.state.existingAnnotationClicked) {
            let annotations = selectedStepClone.attachments[this.state.attachmentIndex].annotations
            annotations.forEach(annotation => {
                if (annotation.Anno_id == this.state.selectedAnnotation.Anno_id) {
                    let str = JSON.parse(annotation.state)
                    str.name = this.state.AnnotationName
                    annotation.state = JSON.stringify(str)
                    annotation.message = this.state.AnnotationText
                }
            })
            selectedStepClone.attachments[this.state.attachmentIndex].annotations = annotations
        } else {
            selectedStepClone.attachments[this.state.attachmentIndex].annotations.push(this.state.selectedAnnotation)
        }
        let steps = this.updateStep(selectedStepClone)
        if (null != this.state.unityContextRef) {
        }
        this.updateSteps(steps, selectedStepClone);
        this.setState({ AnnotationMode: "view", textSelectedInEditorFlag: false, textSelectedInEditor: "", annotationHasBeenCreatedPre: false, addedAnnotation: false })
        this.createAnnotationArray();
    }
    // -------------------------------------------------------------- Deletes an annotation. --------------------------------------------------------------//

    deleteAnnotationCloseImg = (annotationID, index) => {
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        let annotations = selectedStepClone.attachments[index].annotations
        let filteredAnnotations = annotations.filter(annotation => annotation.Anno_id !== annotationID)
        let annotationToDelete = annotations.filter(annotation => annotation.Anno_id == annotationID)
        selectedStepClone.attachments[index].annotations = filteredAnnotations
        let stepContent = selectedStepClone.content
        let matches = getRegexSelection(selectedStepClone.content, new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;', 'g'))
        if (null != matches && matches.length > 0) {
            for (let i = 0; i < matches.length; i++) {
                if (matches[i][1] === annotationID) {
                    let replacementText = matches[i][3]
                    stepContent = stepContent.replace(matches[i][0], replacementText)
                    selectedStepClone.content = stepContent
                    break;
                }
            }
        }
        let steps = this.updateStep(selectedStepClone)
        this.updateSteps(steps, selectedStepClone, false, false, this.props.selectedStepIsChild, false);
        this.setState({ AnnotationMode: "view", AnnotationText: "" }, () => {
            this.createStepsDisplay();
        })
    }

    deleteAnnotation = () => {
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        let annotations = selectedStepClone.attachments[this.state.attachmentIndex].annotations
        let filteredAnnotations = annotations.filter(annotation => annotation.Anno_id !== this.state.selectedAnnotation.Anno_id)
        selectedStepClone.attachments[this.state.attachmentIndex].annotations = filteredAnnotations
        let steps = this.updateStep(selectedStepClone)
        this.updateSteps(steps, selectedStepClone, false, false, this.props.selectedStepIsChild, false);
        this.setState({ AnnotationMode: "view", AnnotationText: "" })
    }
    // -------------------------------------------------------------- Deletes an annotation from WebGL viewer. --------------------------------------------------------------//

    deleteAnnotationFromWebgl = (annotationID) => {
        let selectedStepClone = cloneDeep(this.state.selectedStep)
        let annotations = selectedStepClone.attachments[this.state.attachmentIndex].annotations
        let filteredAnnotations = annotations.filter(annotation => annotation.Anno_id !== annotationID)
        selectedStepClone.attachments[this.state.attachmentIndex].annotations = filteredAnnotations
        let steps = this.updateStep(selectedStepClone)
        this.updateSteps(steps, selectedStepClone);
        this.setState({ AnnotationMode: "view", AnnotationText: "" })
    }
    // -------------------------------------------------------------- Sends a list of annotations to the WebGL viewer. --------------------------------------------------------------//

    sendlist = () => {
        if (checkNotUndefindeNull(this.state.unityContextRef)) {
            this.state.unityContextRef.send("Manager", "SetAnnotations", JSON.stringify({ annotationDatas: this.state.WebglAnnotationList }))
        }
    }
    // -------------------------------------------------------------- Updates the selected step. --------------------------------------------------------------//

    updateSelectedStep = (step) => {
        this.setState({ selectStep: step })
    }
    // -------------------------------------------------------------- Passer function that sets title in Children Components --------------------------------------------------------------//

    setTitle = (newTitle) => {
        this.setState({ title: newTitle },()=> {
            this.saveWorkInstruction()
            this.props.editTitle(newTitle,this.props.wip_ID)
        });
    }
    // -------------------------------------------------------------- Creates an array of annotations for the WebGL viewer. --------------------------------------------------------------//

    createAnnotationArray = () => {
        let WebglList = []
        if (this.state.selectedStep != null) {
            let attachments = this.state.selectedStep.attachments
            const currentAttachment = attachments[this.state.attachmentIndex || 0]
            if (true) {
                if (checkNotUndefindeNull(currentAttachment) && checkNotUndefindeNull(currentAttachment.annotations)) {
                    currentAttachment.annotations.forEach(annotation => {
                        let state = ""
                        if (annotation.state) {
                            state = JSON.parse(annotation.state)
                        } else {
                            state = { name: "Annotation" }
                        }
                        WebglList.push(JSON.parse(state.orgCameraData))
                    })
                }
            }
        }
        this.setState({ WebglAnnotationList: WebglList })
        //WebglList.forEach(data => this.sendAnnotationToThreeJS(data));
        // for (let i = 0; i < WebglList.length; i++) {
        //     this.sendAnnotationToWebgl(WebglList[i])
        // }
    }
    // -------------------------------------------------------------- Builds a dictionary of info items for the given step. --------------------------------------------------------------//

    buildInfoItems = (infoPage, stepId) => {
        let currentStepInfoItems = {}
        if (!isEmpty(infoPage)) {
            for (const [infoItem, infoObject] of Object.entries(infoPage)) {
                if (infoObject.steps.includes(stepId)) {
                    if (!currentStepInfoItems[infoObject.category]) {
                        currentStepInfoItems[infoObject.category] = []
                    }
                    currentStepInfoItems[infoObject.category].push(infoItem)
                }
            }
        }
        return currentStepInfoItems
    }
    // -------------------------------------------------------------- Closes the confirmation message. --------------------------------------------------------------//

    findStepAndPathById = (steps, stepId, path = []) => {
        for (const step of steps) {
            const currentPath = [...path, step._id];
            if (step._id === stepId) {
                return { step: step, path: currentPath };
            }
            if (step.children && step.children.length > 0) {
                const found = this.findStepAndPathById(step.children, stepId, currentPath);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }

    closeConfirmation = (e) => {
        this.setState({ confirmationMessage: "" });
    }
    // -------------------------------------------------------------- Handles opening an embedded attachment. --------------------------------------------------------------//

    openEmbeddedAttachment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let fileName = e.target.innerText
        this.setState({ embeddedFile: fileName },()=>this.renderModal())
    }
    // -------------------------------------------------------------- Initiates preview of the work instruction. --------------------------------------------------------------//

    handleModalOpen = () => {
        this.setState({ isLibraryOpen: true })
    }

    backToWIList = () => {
        let url = "/dashboard/work instructions parent"
        this.props.history.push(url)
    }
    // -------------------------------------------------------------- Renders different modals based on component state. --------------------------------------------------------------//

    renderModal = () => {
        if (this.state.embeddedFile) {
            let embeddedFile = this.state.embeddedFile
            let files = this.state.currentAttachments.filter(attachment => attachment.path === embeddedFile)
            let fileExtension = findExtension(embeddedFile)
            let fileExtensions
            if (audioExtensions.includes(fileExtension)) {
                fileExtensions = audioExtensions
            } else if (videoExtensions.includes(fileExtension)) {
                fileExtensions = videoExtensions
            } else if (imageExtensions.includes(fileExtension)) {
                fileExtensions = imageExtensions
            } else {
                fileExtensions = documentExtensions[0]
            }

            let isImageType = isEqual(fileExtensions, imageExtensions)
            this.setState({modalToDisplay:
             <AttachmentsModal
                callingComponent={"Work Instruction Author File Viewer"}
                isLibraryOpen={this.state.isLibraryOpen}
                handleModalOpen={this.handleModalOpen}
                workInstructionId={this.props.match.params.WIID}
                modalTitle={isImageType ? "Images" : "File List"}
                closeModal={() => {
                    this.setState({ embeddedFile: "", isLibraryOpen: false ,modalToDisplay: null})
                }
                }
                fileTypes={fileExtensions}
                files={files}
                selectedStep={this.state.selectedStep}
                updateStep={this.updateStep}
                updateSteps={this.updateSteps}
            /> })
        } else if (this.state.showingAddInfoForm) {
            this.setState({modalToDisplay:
             <AddInfoFormModal
                modalTitle={<div className="flex-centered" style={{ marginLeft: '1em' }}>
                    {circleExclamation}
                    <p style={{ marginLeft: ".5em" }}>All Alerts</p>
                </div>}
                callingComponent={"Work Instruction Author Add Info"}
                closeModal={this.toggleAllAlertsPage}
                updateInfoPage={this.updateInfoPage}
                infoPage={this.state.infoPage}
                steps={this.state.steps}
                toggleGlobalItem={this.toggleGlobalItem}
                addCategoryToInfoItem={this.saddCategoryToInfoItem}
                editItemName={this.editItemName}
                addItemToInfoPage={this.addItemToInfoPage}
                runInfoPageCleanUp={this.runInfoPageCleanUp}
                addItemToStep={this.addItemToStep} /> })
        } else if (this.state.showingAttachments) {
            let attachmentForLib = this.setCurrentAttachmentsforLibrary()
                this.setState({modalToDisplay:
                    <AttachmentsModal
                    modalTitle={"Attachments Library"}
                    callingComponent={"Work Instruction Author Attachments Library"}
                    closeModal={() => {
                        this.toggleAttachments()
                        this.setState({ embeddedFile: "", isLibraryOpen: false, modalToDisplay: null })
                    }
                    }
                    WIPID={this.state.workInstruction._id}
                    HighlightID={this.state.currentHighlightID}
                    currentAttachments={attachmentForLib}//{this.state.selectedStep ? mapKeys(this.state.selectedStep.attachments, "_id") : {}}
                    previewAttachment={this.previewAttachment}
                    selectedStep={this.state.selectedStep}
                    isPDFViewer={this.state.isPDFViewer}
                    isLibraryOpen={this.state.isLibraryOpen}
                    isLibraryClosing={this.state.isLibraryClosing}
                    handleModalOpen={this.handleModalOpen}
                    currentlySelectedPDFAnnotationID={this.state.currentlySelectedPDFAnnotationID}
                    currentlySelectedPDFAnnotationAttachment={this.state.currentlySelectedPDFAnnotationAttachment}
                    saveNewPDFHighLightAttachments={this.saveNewPDFHighLightAttachments}
                    steps={this.state.steps}
                    updateStep={this.updateStep}
                    updateSteps={this.updateSteps}
                    onTexturesSaved={this.handleTexturesSaved}
                /> })
        } else if (this.state.editingPublicationPage) {
            this.setState({modalToDisplay:
            <PublicationPageModal
                backToWIList={this.backToWIList}
                previewImage={this.state.previewImage}
                setTitle={this.setTitle}
                setPreviewImage={(path) => this.setState({ previewImage: path, isSavable: true })}
                setPreviewImages={(paths) => this.setState({ previewImages: paths, isSavable: true })}
                setInfoChecksRequirement={(bool) => this.setState({ require_info_checks: bool, isSavable: true })}
                infoChecksRequirement={this.state.require_info_checks}
                steps={this.state.steps}
                // PUBLICATION PAGE IS PAYLOAD FROM PublicationPage component
                updatePublicationPage={(publicationPage) => this.setState({ publicationPage, isSavable: true })}
                saveWorkInstruction={this.saveWorkInstruction}
                publicationPage={this.state.publicationPage}
                toggleRelease={this.toggleRelease}
                workInstruction={this.state.workInstruction}
                title={this.state.title}
                WIPID={this.state.workInstruction._id}
                modalTitle={"Publication Page"}
                callingComponent={"Work Instruction Author Publication Page"}
                closeModal={this.togglePublicationPage}
            /> })
        } else if (this.state.editingTags) {
            this.setState({modalToDisplay:
            <EditTagsModal
                workInstructionId={this.state.workInstruction._id}
                currentWorkInstructionTags={this.state.tags}
                modalTitle={"Edit Tags Form"}
                callingComponent={"Work Instruction Author Tags Edit"}
                closeModal={this.toggleEditTags}
                updateTags={(tags) => this.setState({ isSavable: true, editingTags: false, tags })} /> })
        }
        else if (this.state.addingPDFPageWILink && this.state.isPDFViewer) {
           this.setState({modalToDisplay: <EmbeddedWISelect
                attachWIButton={this.addNewWILinkAnnotation}
                SetToClose={() => this.setWILinkModal(false)}
                openNewTab={this.openNewTab}
            >
            </EmbeddedWISelect>})
        }
        else {
            this.setState({modalToDisplay: null})
        }
    }
    // -------------------------------------------------------------- Determines the current attachments for the library view. --------------------------------------------------------------//
    //edited
    setCurrentAttachmentsforLibrary = () => {
        if (this.state.selectedStep) {
            return mapKeys(this.state.selectedStep.attachments, "_id")
        }
        return {}
    }
    // -------------------------------------------------------------- Removes an annotation from the WebGL viewer. --------------------------------------------------------------//

    removeAnnotationFromScreen = (annotationID) => {
        if (checkNotUndefindeNull(this.state.unityContextRef)) {
            this.state.unityContextRef.send("Manager", "SetRemoveAnnotation", annotationID)
        }
    }
    // -------------------------------------------------------------- Initiates an auto-save of the work instruction. --------------------------------------------------------------//

    // -------------------------------------------------------------- Recursively finds and replaces info in the object based on the 'content' key. --------------------------------------------------------------//

    findAllByKey = (target) => {
        if (typeof target === 'object') {
            for (let key in target) {
                if (typeof target[key] === 'object') {
                    this.findAllByKey(target[key]);
                } else {
                    if (key === 'content') {
                        target[key] = replaceSpanWithTextInString(target[key])
                    }
                }
            }
        }
        return target
    }
    // -------------------------------------------------------------- Checks step content for temporary highlights. --------------------------------------------------------------//
    checkStepContentForTempHighlight = (steps) => {
        let spans = document.getElementsByClassName("TempHighlight")
        if (spans.length > 0) {
            let test = this.findAllByKey(steps)
        }
        return steps
    }

    // -------------------------------------------------------------- Highlights text based on a search string. --------------------------------------------------------------//

    highlighter = (text) => {
        return <Highlighter
            highlightClassName="YourHighlightClass"
            searchWords={[this.state.searchString]}
            autoEscape={true}
            className="highlightDivFont noWrapTitle"
            textToHighlight={text}
        />
    }

    stepMatchesSearch = (step, normalizedSearch) => {
        if (!normalizedSearch) {
            return true;
        }

        const title = (step.title || "").toLowerCase();
        let content = (step.content || "").toLowerCase();
        
        // Remove annotation markers (WI links) from content before searching
        // Format: &lt;WI,title,id,hash&gt; should only match the title part (first capture group)
        // Replace the entire marker with just the title text, so search only matches visible text
        // Pattern matches: &lt;WI,title,id,hash&gt; -> becomes just "title"
        content = content.replace(/&lt;wi,(.*?),(.*?),(.*?)\.&gt;/gi, '$1');
        
        // Remove Annotation markers - format: &lt;Annotation,id,index,text.&gt;
        // Replace with just the text part (third capture group) so search only matches visible text
        // Pattern matches: &lt;Annotation,id,index,text.&gt; -> becomes just "text"
        content = content.replace(/&lt;annotation,(.*?),(.*?),(.*?)\.&gt;/gi, '$3');

        return title.includes(normalizedSearch) || content.includes(normalizedSearch);
    }

    flattenStepTree = (step, stepNum, accumulator) => {
        accumulator.push({ step, stepNum });

        if (Array.isArray(step.children) && step.children.length > 0) {
            step.children.forEach((child, index) => {
                const childNumber = `${stepNum}.${index + 1}`;
                this.flattenStepTree(child, childNumber, accumulator);
            });
        }
    }

    // -------------------------------------------------------------- Saves work instruction data, handles release and updates. --------------------------------------------------------------//

    saveWorkInstruction = (togglingRelease, nextReleaseState, data, callback) => {
        let workInstruction = cloneDeep(this.state.workInstruction);
        let checkedSteps = cloneDeep(this.state.steps);
        checkedSteps = this.checkStepContentForTempHighlight(checkedSteps);

        workInstruction.steps = this.updateStepOrder(checkedSteps);
        workInstruction.WipGroup = this.state.WipGroup;
        workInstruction.PDFViewerHighlights = this.state.annoList;
        // Ensure we do not overwrite existing previewImages with undefined
        if (Array.isArray(this.state.previewImages) && this.state.previewImages.length > 0) {
            workInstruction.previewImages = this.state.previewImages;
        }
        workInstruction.workStatus = "Not Started";
        workInstruction.info_page = JSON.stringify(this.state.infoPage);
        workInstruction.tags = this.state.tags;

        // Check if 'data' is the comprehensive object from PublicationPage release
        if (data && typeof data === 'object' && data.hasOwnProperty('publicationPagePayload')) {
            workInstruction.title = data.title;
            workInstruction.preview_img = data.previewImageName;
            workInstruction.publication_page = data.publicationPagePayload;
            workInstruction.require_info_checks = data.infoChecksRequirement;
        } else {
            // Fallback for other save calls (auto-save, toolbar save)
            // 'data' in this case would be the old publicationPagePayload or null
            workInstruction.title = this.state.title;
            workInstruction.preview_img = this.state.previewImage;
            workInstruction.publication_page = data ? data : this.state.publicationPage;
            workInstruction.require_info_checks = this.state.require_info_checks;
        }

        if (togglingRelease) {
            workInstruction.release = nextReleaseState;
        } else {
             workInstruction.release = this.state.isReleased;
        }

        this.props.updateWorkInstruction(workInstruction).then((data) => {
            const confirmationMessage = togglingRelease
                ? (nextReleaseState
                    ? `Your Work Instruction Has Been Released. It may take a few minutes before it appears in the Assignments Page.`
                    : 'Your Work Instruction Has Been Unreleased.')
                : "Your Work Instruction has been saved.";

            // Clear message first to force animation restart
            this.setState({ confirmationMessage: "" }, () => {
                // Then set the actual message in next tick
                setTimeout(() => {
                    this.setState({
                        confirmationMessage,
                        isReleased: togglingRelease ? nextReleaseState : this.state.isReleased,
                        isSavable: false,
                        ...(data && { publicationPage: data.publicationPagePayload })
                    }, () => {
                        if (callback) {
                            callback();
                        } else {
                            setTimeout(this.closeConfirmation, 10000);
                        }
                        if (togglingRelease && nextReleaseState) {
                            setTimeout(() => this.backToWIList(), 100);
                        }
                    });
                }, 0);
            });

        }).catch((err) => {
            console.log(err);
            // Handle error - maybe show a message?
            // window.alert("Failed to save/release work instruction.");
            //  if (callback) {
            //     callback(err); // Pass error to callback if needed
            // }
        });
    }
    // -------------------------------------------------------------- Handles the selection of a step. --------------------------------------------------------------//

    updateStepOrder = (treeData) => {
        const stepLoop = (steps) => {
            for (let i = 0; i < steps.length; i++) {
                steps[i].order = i + 1;
                if (steps[i].children.length > 0) {
                    stepLoop(steps[i].children)
                }
            }
        }

        for (let i = 0; i < treeData.length; i++) {
            treeData[i].order = i + 1;
            if (treeData[i].children.length > 0) {
                stepLoop(treeData[i].children)
            }
        }

        return treeData
    }
    // -------------------------------------------------------------- Handles the selection of a step. --------------------------------------------------------------//


    selectStep = (ss, path, stepClick, attachmentIndex = 0) => {
        if (ss && (!this.state.selectedStep || ss._id !== this.state.selectedStep._id)) {
            console.log('[WIAuthorSteps] selectStep called', { newStepId: ss._id, prevStepId: this.state.selectedStep?._id });
            let selectedStep = this.state.steps.find(step => step._id === ss._id);
            if (!selectedStep) {
                selectedStep = ss;
            }
    
            let currentStepInfoItems = this.buildInfoItems(this.state.infoPage, selectedStep._id);
            let currentAttachments = selectedStep.attachments || [];
            if (this.state.isPDFViewer) {
                currentAttachments = [];
            }
    
            let stepIsChild = Array.isArray(path) && path.length > 1;
            let stepID = "div_step_" + selectedStep._id;
            let isModel = this.isAttachmentModel(selectedStep, attachmentIndex);
    
            this.setState({
                selectedStep,
                path: Array.isArray(path) ? path : [path],
                currentAttachments,
                editingContent: false,
                editingStepAlerts: false,
                toggleAnnotation: false,
                currentStepInfoItems,
                attachmentIndex: attachmentIndex,
                selectedStepIsChild: stepIsChild,
                selectedStepDivID: stepID,
                currentStepAttachmentModel: isModel,
                textSelectedInEditor: "",
                textSelectedInEditorFlag: false,
                modelsLoaded: this.IsModelAttachmentSameAfterStepSelection(selectedStep)
            }, () => {
                const done = this.findDoneStatusByStepId(selectedStep._id);
                console.log('[WIAuthorSteps] selectStep post-state', { selectedStepId: selectedStep._id, done });
                this.updateContentSpan();
                this.createStepsDisplay();
                this.createAnnotationArray();
                this.checkIfAttachmentHasAnnotationArray();
                if (stepClick) {
                    let node = document.getElementsByClassName("selected-container");
                    if (node.length > 0) {
                        node[0].click();
                    }
                }
                // Auto-scroll to the newly selected step
                this.scrollToSelectedStep(selectedStep._id);
            });
        }
    }
    
    // -------------------------------------------------------------- Scrolls to the selected step in the display --------------------------------------------------------------//
    
    scrollToSelectedStep = (stepId) => {
        // Use setTimeout to ensure the DOM has updated with the new step display
        setTimeout(() => {
            const stepDiv = document.getElementById(`div_step_${stepId}`);
            const stepContainer = document.getElementById("step-Div-Parent");
            
            if (stepDiv && stepContainer) {
                // Calculate if the step is in view
                const containerRect = stepContainer.getBoundingClientRect();
                const stepRect = stepDiv.getBoundingClientRect();
                
                const isInView = (
                    stepRect.top >= containerRect.top &&
                    stepRect.bottom <= containerRect.bottom
                );
                
                // Only scroll if the step is not fully visible
                if (!isInView) {
                    stepDiv.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "nearest"
                    });
                }
            }
        }, 100);
    }

    // Returns current done status for a step id based on doneStepList
    findDoneStatusByStepId = (stepId) => {
        const s = this.state.doneStepList?.find(item => item._id === stepId);
        return !!(s && s.done);
    }

    IsModelAttachmentSameAfterStepSelection = (newStep) => {
        // Get current step and attachment
        const currentStep = this.state.selectedStep;
        if (!currentStep || !newStep) return false;

        const currentAttachments = currentStep.attachments;
        const newAttachments = newStep.attachments;

        // Check if both steps have attachments
        if (!currentAttachments?.length || !newAttachments?.length) return false;

        const currentAttachment = currentAttachments[this.state.attachmentIndex || 0];
        const newAttachment = newAttachments[0];

        // Check if both attachments exist
        if (!currentAttachment || !newAttachment) return false;

        // Get file extensions
        const currentExt = findExtension(currentAttachment.path);
        const newExt = findExtension(newAttachment.path);

        // Check if both are 3D models
        const isCurrentModel = isModel(currentExt);
        const isNewModel = isModel(newExt);

        // Return false if either attachment is not a 3D model
        if (!isCurrentModel || !isNewModel) return false;

        // Compare paths to check if it's the same model
        return true
    }
    // -------------------------------------------------------------- Initiates a continuous loop to navigate after a step deletion. --------------------------------------------------------------//

    stepDeleted = () => {
        let intervalId = setInterval(() => {
            let id = this.state.path[this.state.path.length - 1]
            let step = document.getElementById("div_step_" + id)
            if (step) {
                console.log(step)
                step.click()
                clearInterval(intervalId)
            }
        }, 100)
    }
    // -------------------------------------------------------------- Stores color information for an attachment. --------------------------------------------------------------//

    storeColor = (color) => {
        let selectedStep = this.state.selectedStep
        let currentAttachments = this.state.currentAttachments
        currentAttachments[this.state.attachmentIndex].background_color = color
        selectedStep.attachments = currentAttachments
        let steps = this.updateStep(selectedStep)
        this.updateSteps(steps, selectedStep)
    }
    // -------------------------------------------------------------- Stores camera data for an attachment. --------------------------------------------------------------//

    storeCameraData = (cameraData) => {
        let selectedStep = this.state.selectedStep
        let currentAttachments = this.state.currentAttachments
        currentAttachments[this.state.attachmentIndex].cameraData = cameraData
        selectedStep.attachments = currentAttachments
        let steps = this.updateStep(selectedStep)
        this.updateSteps(steps, selectedStep);
        this.setState({ currentCameraPlacement: cameraData })
    }
    // -------------------------------------------------------------- Handles the submission of edited title data. --------------------------------------------------------------//

    submitTitleEdit = (title) => {
        this.setState({
            editingTitle: false,
            title,
        })
    }
    // -------------------------------------------------------------- Toggles the display of the "Add Info" form. --------------------------------------------------------------//

    toggleAllAlertsPage = (e) => {
        this.setState({ showingAddInfoForm: !this.state.showingAddInfoForm, modalToDisplay: null },()=>this.renderModal());
    }
    // -------------------------------------------------------------- Toggles the display of attachments. --------------------------------------------------------------//

    toggleAttachments = (e) => {
        if (this.state.showingAttachments) {
            // Closing: trigger animation first
            this.setState({ isLibraryClosing: true }, () => {
                setTimeout(() => {
                    this.setState({ 
                        showingAttachments: false, 
                        isLibraryClosing: false,
                        isLibraryOpen: false,
                        modalToDisplay: null
                    }, () => {
                        // When closing attachments library, just click the selected container
                        // The componentDidUpdate in ModelDisplay will handle texture reloading automatically
                        let node = document.getElementsByClassName("selected-container")
                        if (node.length > 0) {
                            node[0].click();
                        }
                    });
                }, 250); // Match ChatButton animation duration
            });
        } else {
            // Opening: set states and render modal
            this.setState({ showingAttachments: true }, () => {
                this.renderModal()
            });
        }
    }
    // -------------------------------------------------------------- Toggles the editing state for tags. --------------------------------------------------------------//

    toggleEditTags = (e) => {
        return this.setState ({ editingTags: !this.state.editingTags },()=>{
           this.renderModal();
            if(!this.state.editingTags){
                this.setState({modalToDisplay: null})         
            }
        });
    }
    // -------------------------------------------------------------- Toggles the publication page with or without release. --------------------------------------------------------------//

    togglePublicationPage = (e, withRelease) => {
        // Remove the 'withRelease' logic and setTimeout
        console.log("togglePublicationPage",!this.state.editingPublicationPage)
        return this.setState({ editingPublicationPage: !this.state.editingPublicationPage },()=>{
            this.renderModal();
            if(!this.state.editingPublicationPage){
                this.setState({modalToDisplay: null})
            }
        })
          
    }
    // -------------------------------------------------------------- Toggles the selected text in the editor. --------------------------------------------------------------//

    toggleTextSelectedInEditor = (selectedText, range) => {
        console.log("selected text in editorsdsds: ", selectedText);
        let flag = false;
        if (checkNotUndefindeNull(selectedText) && selectedText != "") { flag = true }
        this.setState({ textSelectedInEditorFlag: flag, textSelectedInEditor: selectedText, textSelectionRange: range, annotationHasBeenCreatedPre: flag });
    }
    // -------------------------------------------------------------- Toggles the work instruction release state. --------------------------------------------------------------//

    toggleRelease = () => {
        return this.saveWorkInstruction(true, !this.state.isReleased);
    }
    // -------------------------------------------------------------- Toggles the editing time state. --------------------------------------------------------------//

    toggleEditingTime = (editingTime) => {
        this.setState({ editingTime: editingTime })
    }
    // -------------------------------------------------------------- Updates the info page. --------------------------------------------------------------//

    updateInfoPage = (infoPage) => {
        let step = this.state.selectedStep
        step.infoPage = infoPage
        let steps = this.updateStep(step)
        this.updateSteps(steps, step)
        this.setState({ infoPage, isSavable: true }, () => {
            this.saveWorkInstruction();
        });
    }

    getInfoPage = () => {
        return this.state.infoPage
    }
    // -------------------------------------------------------------- Renders an icon for step alerts. --------------------------------------------------------------//

    renderStepAlertsIcon = () => {
        let infoPage = this.state.infoPage && !isEmpty(this.state.infoPage) ? this.state.infoPage : null
        let numStepAlerts = 0
        let infoList = []
        if (infoPage) {
            let infoItems = Object.keys(infoPage)
            let currentItems = {}
            infoItems.forEach(item => {
                let currentStep = this.state.selectedStep;
                let currentStepId = currentStep ? currentStep._id : 0
                let testItem = infoPage[item];
                testItem.steps.forEach(stepId => {
                    let isGlobal = testItem.global
                    let isIncluded = stepId === currentStepId
                    if (isGlobal || isIncluded) {
                        if (currentItems[item]) {
                            currentItems[item].push(currentStep)
                        } else {
                            currentItems[item] = [currentStep]
                        }
                    }
                })
            })

            numStepAlerts = Object.keys(currentItems).length
            infoList = Object.keys(currentItems).map(item => (<li key={`${item}`}> - {item}</li>))

        }
        let tooltipText = numStepAlerts ?
            <ul>
                <p className="underline">Current Alerts</p>
                {infoList}
            </ul>
            : "Edit Step Alerts";
        return this.props.editingStepAlerts ?
            closeStepAlertsIcon(numStepAlerts, this.state.toggleStepAlerts, tooltipText, false) :
            openStepAlertsIcon(numStepAlerts, this.state.toggleStepAlerts, tooltipText, false)
    }
    // -------------------------------------------------------------- Updates the toggleAnnotation state. --------------------------------------------------------------//

    updateToggleAnnotation = (toggleAnnotation) => {
        this.setState({ toggleAnnotation: toggleAnnotation, editingStepAlerts: false });
    }
    // -------------------------------------------------------------- Updates the editingStepAlerts state. --------------------------------------------------------------//

    updateEditingStepAlerts = (e) => {
        e.stopPropagation()
        let toggleStepAlert = this.state.editingStepAlerts
        this.setState({ editingStepAlerts: !toggleStepAlert, toggleAnnotation: false, editingContent: false }, () => this.createStepsDisplay())
    }
    // -------------------------------------------------------------- Updates the toggleStepContent state. --------------------------------------------------------------//

    updateToggleStepContent = () => {
        //,()=>this.createStepsDisplay()
        this.setState({
            editingStepAlerts: false,
            toggleAnnotation: false,
            //editingTime: false
        })

    }
    // -------------------------------------------------------------- Updates a step's data. --------------------------------------------------------------//

    updateStep = (updatedStep) => {
        let steps = this.state.steps
        updatedStep.content = replaceSpanWithTextInString(updatedStep.content)
        const updatedSteps = steps.map(step => {
            step.content = replaceSpanWithTextInString(step.content)
            if (checkNotUndefindeNull(step.children) && step.children.length > 0) {
                step.children = step.children.map(kidsteps => {
                    kidsteps.content = replaceSpanWithTextInString(kidsteps.content)
                    if (kidsteps._id === updatedStep._id) {
                        return updatedStep
                    }
                    else {
                        return kidsteps
                    }
                })
            }
            if (step._id === updatedStep._id) {
                return updatedStep
            }
            return step
        }
        )
        return updatedSteps
    }
    // -------------------------------------------------------------- Updates multiple steps. --------------------------------------------------------------//

    updateSteps = async (steps, recentlyAddedStep, withClearData, nodeDeletion, isSubStep, autoEditTitle, autoSave = false) => {
        let path
        let flatSteps = getFlatDataFromTree({
            treeData: this.state.steps,
            getNodeKey: (({ node }) => node._id),
            ignoreCollapsed: false,
        })
        if (withClearData || nodeDeletion) {
            let index = null
            flatSteps.forEach(({ node }, i) => {
                if (node._id === this.state.selectedStep._id) {
                    index = i
                }
            })
            let previousStep = index >= 1 ? flatSteps[index - 1] : ""
            let nextStep = index >= 0 ? flatSteps[index + 1] : ""
            let node = previousStep || nextStep
            path = node.path ? node.path : flatSteps[index].path
            let selectedStep = node.node
            let selectedStepDivID = "div_step_" + selectedStep._id

            return this.setState({ 
                steps, 
                path, 
                isSavable: true, 
                selectedStep, 
                selectedStepDivID,
                editingStepTitle: false  // Reset editing state after deletion
            },()=>{
                this.createStepsDisplay()
                if (autoSave) { this.saveWorkInstruction(); }
            })
        }
        if (recentlyAddedStep) {
            // *** Ensure the newly added step has a default title ***
            if (!recentlyAddedStep.title) {
                recentlyAddedStep.title = 'Step Title';
            }
            // ******************************************************

            let r_steps = []
            if (!this.state.isPDFViewer) { r_steps = recentlyAddedStep.attachments }
            //if(autoEditTitle ){this.setState({editingStepTitle: true})} 
            // await this.promisedSetState(steps,true,recentlyAddedStep,r_steps)
            // return 
            return this.setState({ steps, isSavable: true, selectedStep: recentlyAddedStep, currentAttachments: r_steps }, () => {
                if (autoEditTitle) { this.setState({ editingStepTitle: true }) }
                this.createStepsDisplay(); // Force re-render of steps display after state is set
                if (autoSave) { this.saveWorkInstruction(); }
            })
        }
        return this.setState({ steps, isSavable: true }, () => {
            if (autoSave) { this.saveWorkInstruction(); }
        })
    }

    // -------------------------------------------------------------- Sets the selected step. --------------------------------------------------------------//

    setSelectedStep = (stepID) => {
        if (this.state.selectedStepDivID != stepID) {
        }

    }
    // -------------------------------------------------------------- Updates the Unity context and model loading status. --------------------------------------------------------------//

    updateUnityContext = (context, modelsLoaded) => {
        if (null != context) {
        }

        this.setState({ unityContextRef: context, modelsLoaded })
    }
    // -------------------------------------------------------------- Updates the tree data. --------------------------------------------------------------//

    updateTree = (steps, addedNode, withClearData) => {
        this.updateSteps(steps, addedNode ? addedNode : this.state.selectedStep, withClearData)
    }
    // -------------------------------------------------------------- Updates the editor reference. --------------------------------------------------------------//

    updateEditorRef = (editorRef) => {
        this.setState({ editorRef })
    }
    // -------------------------------------------------------------- Checks if an annotation is active. --------------------------------------------------------------//

    checkIfAnnotationIsActive = (divID) => {
        if ((this.state.selectedStepDivID).toString().trim() === (divID).toString().trim()) {
            return true;
        }
        return false;
    }
    // -------------------------------------------------------------- Generates a random ID. --------------------------------------------------------------//

    makeid = (length) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    // -------------------------------------------------------------- Selects a step when a step div is clicked. --------------------------------------------------------------//

    stepDivSelectStep = (e, step, path, randString) => {
        // Guard against programmatic/synthetic events that aren't real user clicks
        // Real click events will have nativeEvent with isTrusted = true
        if (!e.nativeEvent || !e.nativeEvent.isTrusted) {
            console.log('[WIAuthorSteps] stepDivSelectStep - IGNORING synthetic/programmatic event');
            return;
        }
        
        // Allow clicks on WI links and other interactive elements to propagate
        const clickedElement = e.target;
        const isWILink = clickedElement?.classList?.contains('WIClickable') || 
                         clickedElement?.classList?.contains('WIL') ||
                         clickedElement?.classList?.contains('WL') ||
                         clickedElement?.closest?.('.WIClickable') ||
                         clickedElement?.closest?.('.spansClick');
        
        if (isWILink) {
            // Let the WI link handle its own click
            return;
        }
        
        if ("div_step_" + step._id != this.state.selectedStepDivID) {
            this.selectStep(step, [path], true)

        } else {
            e.stopPropagation();
            if (typeof e.target.click !== "undefined")
                e.target.click();
        }

    }
    // -------------------------------------------------------------- Shows an annotation. --------------------------------------------------------------//

    showAnnotation = (event) => {
        event.stopPropagation()
        let index = event.target.id.split("~~~")[1]
        let annotationID = event.target.id.split("~~~")[0]
        if (this.state.selectedStepDivID !== event.srcElement.offsetParent.parentElement.parentElement.id) {
            event.srcElement.offsetParent.parentElement.parentElement.click();
            let id = ""
            this.setState({ attachmentIndex: index }, () => {

                this.sendAnnotationToWebgl(annotationID)
            })


        }
        else if (this.state.attachmentIndex !== index) {
            this.setState({ attachmentIndex: index }, () => {

                this.sendAnnotationToWebgl(annotationID)
            })
        }
        else {
            this.sendAnnotationToWebgl(annotationID)
        }
    }

    // -------------------------------------------------------------- Opens WI link in new tab. --------------------------------------------------------------//

    showWI = async (event) => {
        event.stopPropagation();
        const linkElement = event.target?.closest ? event.target.closest('.WIClickable') : null;
        const wiTitle = linkElement?.querySelector('.wi-link-text')?.innerText
            || linkElement?.innerText
            || event.target?.innerText
            || '';
        const wiId = linkElement?.id || event.target?.id;
        if (!wiId) return;

        try {
            const isOnline = await online();
            if (!isOnline) {
                alert('Nested Work Instructions are not available offline. Connect to the network to open.');
                return;
            }
            // Ensure latest WI exists server-side before opening
            await fetchWorkInstruction(wiId);
            this.props.addTab(wiTitle, wiId);
        } catch (err) {
            console.error('Failed to fetch WI info for nested tab:', err);
            const status = err?.response?.status;
            const msg = err?.response?.data?.message || '';
            if (status === 404 || status === 410 || /deleted|not found/i.test(msg)) {
                alert('This Work Instruction has been deleted.');
            } else {
                alert('Failed to load the nested Work Instruction. Please try again.');
            }
        }
    }
    // -------------------------------------------------------------- delete wi link. --------------------------------------------------------------//

    deleteWI = (event) => {
        console.log('[WIAuthorSteps - deleteWI] Delete WI button clicked')
        console.log('[WIAuthorSteps - deleteWI] Event target:', event.target)
        console.log('[WIAuthorSteps - deleteWI] Event target ID:', event.target.id)
        
        event.stopPropagation()
        const wiID = event.target.id.split("_")[1]
        console.log('[WIAuthorSteps - deleteWI] Extracted WI ID:', wiID)
        console.log('[WIAuthorSteps - deleteWI] Calling deleteWILink')
        
        this.deleteWILink({ wiID: wiID })

    }
    
    // -------------------------------------------------------------- Deletes a single PDF annotation (Steps version). --------------------------------------------------------------//
    
    deleteSingleAnnotation = async (wi) => {
        console.log('[WIAuthorSteps - deleteSingleAnnotation] Starting deletion process')
        console.log('[WIAuthorSteps - deleteSingleAnnotation] Selected annotation:', this.state.selectedAnnotation)
        console.log('[WIAuthorSteps - deleteSingleAnnotation] WI parameter:', wi)
        
        try {
            // Always delete the PDF annotation/highlight first  
            console.log('[WIAuthorSteps - deleteSingleAnnotation] Calling deletePDFAnnotation with:', this.state.selectedAnnotation.elementName)
            await this.deletePDFAnnotation(this.state.selectedAnnotation.elementName)
            console.log('[WIAuthorSteps - deleteSingleAnnotation] PDF annotation deleted successfully')
        } catch (e) {
            console.error('Error deleting PDF annotation:', e)
        }
        
        // For Steps WI links, also call deleteWILink to handle WipGroup and step content
        if (wi) {
            try {
                console.log('[WIAuthorSteps - deleteSingleAnnotation] Calling deleteWILink with wiID:', wi)
                this.deleteWILink({ wiID: wi })
                console.log('[WIAuthorSteps - deleteSingleAnnotation] WI link deletion called')
            } catch (e) {
                console.error('Error deleting WI link:', e)
            }
        }
        
        // Hard refresh from backend to ensure highlights are in sync after deletion
        try {
            console.log('[WIAuthorSteps - deleteSingleAnnotation] Refreshing WI data from backend')
            const res = await fetchWorkInstruction(this.props.wip_ID)
            const wiData = cloneDeep(res.data)
            console.log('[WIAuthorSteps - deleteSingleAnnotation] Fresh WI data PDFViewerHighlights:', wiData.PDFViewerHighlights)
            this.setState({
                workInstruction: wiData,
                PDFViewerHighlights: wiData.PDFViewerHighlights,
                annoList: wiData.PDFViewerHighlights,
            })
            console.log('[WIAuthorSteps - deleteSingleAnnotation] State updated with fresh data')
        } catch (e) {
            console.error('Error refreshing WI data:', e)
        }
    }
    // -------------------------------------------------------------- delete ma link. --------------------------------------------------------------//

    deleteMA = (event) => {
        event.stopPropagation()
        // Parse annotation id and attachment index from element id: close_<AnnoId>~~~<attachmentIndex>
        try {
            const idStr = event.target.id || ""
            const parts = idStr.split("_")
            const rest = parts.length > 1 ? parts[1] : ""
            const [annotationID, indexStr] = rest.split("~~~")
            const attachmentIndex = Number.parseInt(indexStr, 10) || 0

            // Find the step container that this delete icon belongs to
            const container = event.target.closest('.step-display-div')
            const stepId = container && container.id && container.id.startsWith('div_step_')
                ? container.id.replace('div_step_', '')
                : (this.state.selectedStep ? this.state.selectedStep._id : null)

            if (!annotationID || stepId == null) {
                return
            }

            this.deleteAnnotationCloseImgForStep(annotationID, attachmentIndex, stepId)
        } catch (e) {
            console.error('[WIAuthorSteps] deleteMA failed:', e)
        }
    }

    // Safer deletion that targets the correct step by id regardless of current selection
    deleteAnnotationCloseImgForStep = (annotationID, attachmentIndex, stepId) => {
        const found = this.findStepAndPathById(this.state.steps, stepId)
        const targetStep = found ? cloneDeep(found.step) : null
        if (!targetStep) {
            console.warn('[WIAuthorSteps] deleteAnnotationCloseImgForStep: step not found', { stepId })
            return
        }
        const attachments = Array.isArray(targetStep.attachments) ? targetStep.attachments : []
        const att = attachments[attachmentIndex]
        if (!att || !Array.isArray(att.annotations)) {
            console.warn('[WIAuthorSteps] deleteAnnotationCloseImgForStep: attachment/annotations not found', { attachmentIndex })
            return
        }


        // Filter out the annotation from the attachment
        const filteredAnnotations = att.annotations.filter(a => a.Anno_id !== annotationID)
        targetStep.attachments[attachmentIndex] = { ...att, annotations: filteredAnnotations }

        // Remove inline token from the step content
        let stepContent = targetStep.content || ""
        const matches = getRegexSelection(stepContent, new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;', 'g'))
        if (matches && matches.length > 0) {
            for (let i = 0; i < matches.length; i++) {
                if (matches[i][1] === annotationID) {
                    const replacementText = matches[i][3]
                    stepContent = stepContent.replace(matches[i][0], replacementText)
                    break
                }
            }
        }
        targetStep.content = stepContent

        // Persist into steps without switching selection
        const steps = this.updateStep(targetStep)
        this.updateSteps(steps, null, false, false, this.props.selectedStepIsChild, false)
        this.setState({ AnnotationMode: "view", AnnotationText: "" }, () => {
            this.createStepsDisplay()
        })
    }
    // -------------------------------------------------------------- Gets the path for a given randString. --------------------------------------------------------------//

    getPath = (randString) => {
        let link = this.state.pathLink.filter(l => l.id == randString)
        return link.path
    }
    // -------------------------------------------------------------- Toggles the step dropdown. --------------------------------------------------------------//
    renderAttachmentLibraryIcon = (attachments) => {
        let length = attachments.length
        this.toggleAttachments()
        let attachmentsList = attachments.map(attachment => {
            return <li key={`${attachment._id}`}>{attachment.path}</li>
        })
        let tooltipText = length ? <ul>
            <p className="underline">Current Attachments</p>
            {attachmentsList}
        </ul>
            : "Open Attachment Library"
        return addAttachmentIcon(length, this.state.toggleAttachments, tooltipText, false, this.state.displayAttachments)
    }
    // -------------------------------------------------------------- Submits an edited step name. --------------------------------------------------------------//

    submitStepNameEdit = (e, stepName) => {
        e.preventDefault()
        let updatedStep = this.state.selectedStep
        updatedStep.title = stepName
        let steps = this.updateStep(updatedStep)
        this.updateSteps(steps, updatedStep)
        this.setState({ editingStepTitle: false }, () => this.createStepsDisplay())
    }
    // -------------------------------------------------------------- Updates the step name during creation. --------------------------------------------------------------//

    updateStepNameOnCreation = (step, stepName) => {
        // Use the helper function to get a new steps array with the title updated
        const newSteps = this.updateStepTitleInTree(this.state.steps, step._id, stepName);
        // Only update the steps array and the savable flag in the state.
        // Avoid calling updateSteps(steps, updatedStep) which changes selectedStep.
        this.setState({ steps: newSteps, isSavable: true });
    }
    // -------------------------------------------------------------- Toggles the editing state for step titles. --------------------------------------------------------------//

    toggleEditingStepTitle = () => {
        // Prevent editing if in Lite View
        if (this.props.isLiteView) {
            return;
        }
        let editTitle = this.state.editingStepTitle
        this.setState({ editingStepTitle: !editTitle }, () => this.createStepsDisplay());
    }
    // -------------------------------------------------------------- Determines if an attachment is a 3D model. --------------------------------------------------------------//

    isAttachmentModel = (step, index) => {
        let attachments = step ? step.attachments : this.state.selectedStep.attachments
        const currentAttachment = attachments[index ? index : this.state.attachmentIndex]
        const filename = this.state.viewingAttachment || currentAttachment ? currentAttachment.path : ""
        if (typeof filename == "undefined" || filename == null) {
            return false;
        }
        let ext = findExtension(filename);
        let typeModel = isModel(ext)
        return typeModel
    }
    // -------------------------------------------------------------- Closes the content editor and resets related states. --------------------------------------------------------------//

    closeOutContentEditor = (clickedToggle) => {
        if (clickedToggle) {
            this.setState({
                AnnotationMode: "view",
                textSelectedInEditorFlag: false,
                textSelectedInEditor: "",
                annotationHasBeenCreatedPre: false,
                addedAnnotation: false,
            })
        }
        else {
            this.setState({
                AnnotationMode: "view",
                textSelectedInEditorFlag: false,
                textSelectedInEditor: "",
                annotationHasBeenCreatedPre: false,
                addedAnnotation: false,
                editingStepTitle: false,
                editingStepAlerts: false,
                toggleAnnotation: false,
                editingContent: false
            }, () => this.createStepsDisplay())
        }

    }
    // -------------------------------------------------------------- Toggles the content form. --------------------------------------------------------------//

    toggleContentForm = (e) => {
        e.stopPropagation()
        console.log(`[WI ${this.props.wip_ID}] toggleContentForm called, current editingContent:`, this.state.editingContent);
        console.log(`[WI ${this.props.wip_ID}] Active element:`, document.activeElement);
        console.log(`[WI ${this.props.wip_ID}] Selected step:`, this.state.selectedStep?._id);
        if (e.target.localName === "button") { return this.openEmbeddedAttachment(e) }
        let toggleContent = this.state.editingContent;
        this.setState({
            editingContent: !toggleContent, editingStepTitle: false,
            editingStepAlerts: false, toggleAnnotation: false
        }, () => { 
            console.log(`[WI ${this.props.wip_ID}] After toggle, editingContent is now:`, !toggleContent);
            this.createStepsDisplay() 
        })
    }
    // -------------------------------------------------------------- Checks if path links exist for a step. --------------------------------------------------------------//

    checkPathListExist = (step, step_id, pathLinks) => {
        let item = {
            id: step_id,
            path: [step._id]
        }

        for (const link of pathLinks) {
            if (link.id === item.id) {
                return true
            }

        }
        return false
    }
    // -------------------------------------------------------------- Creates a path link for a step. --------------------------------------------------------------//

    createPathLink = (step, randString) => {

        let item = {
            id: randString,
            path: [step._id]
        }

        return item
        //this.displayArray.push(item)
        // this.setState({pathList:item})
    }
    // -------------------------------------------------------------- Gets the current attachment index. --------------------------------------------------------------//

    getAttachmentIndex = () => {
        return this.state.attachmentIndex
    }
    // -------------------------------------------------------------- Checks if an annotation has been created previously. --------------------------------------------------------------//

    getAnnotationHasBeenCreatedPre = () => {
        return this.state.annotationHasBeenCreatedPre
    }
    // -------------------------------------------------------------- Gets the selected annotation. --------------------------------------------------------------//

    getSelectedAnnotation = () => {
        return this.state.selectedAnnotation
    }
    // -------------------------------------------------------------- Gets the text selected in the editor. --------------------------------------------------------------//

    getTextSelectedInEditor = () => {
        return this.state.textSelectedInEditor
    }
    // -------------------------------------------------------------- Checks if an annotation has been added. --------------------------------------------------------------//

    getAddedAnnotation = () => {
        return this.state.addedAnnotation
    }

    getCurrentStepAttachmentModel = () => {
        return this.state.currentStepAttachmentModel
    }
    // -------------------------------------------------------------- THIS CREATES THE DIV THAT RENDERS ALL STEPS --------------------------------------------------------------//
    createStepDiv = (step, stepNum, pathLinks) => {
        if (this.checkPathListExist(step, step._id, pathLinks)) {
            return null;
        }
        let randString = this.makeid(15)
        let divID = "div_step_" + step._id

        pathLinks.push(this.createPathLink(step, step._id))
        let title = ""
        if (step.title && step.title.length > 0) {
            title = step.title
        }
        else {
            // Use the step number as the default title instead of generic 'Step Title'
            title = stepNum.toString()
            this.updateStepNameOnCreation(step, title)
        }

        return <li><div className={`step-display-div shadow  ${this.state.selectedStepDivID == divID ? "selected-step-border" : ""}`} id={divID} onClick={(e) => this.stepDivSelectStep(e, step, step._id, randString)} key={`${randString}`} >
             <div className={`step-display-div-header ${this.state.selectedStepDivID == divID ? "selected-step-header-highlight" : ""}`}>

                {/* PUT STEP # HERE */}
                <h3 style={{ marginLeft: "10px" }}>{stepNum}</h3>
                {this.state.editingStepTitle && this.state.selectedStepDivID == divID ?
                    <EditStepNameFieldContainer
                        stepTitle={this.state.selectedStep.title && this.state.selectedStep.title.length > 0 ? this.state.selectedStep.title : 'Step Title'}
                        submitStepNameEdit={this.submitStepNameEdit}
                        cancel={() => this.setState({ editingStepTitle: false }, () => this.createStepsDisplay())}
                    /> : <h3 style={{ marginLeft: "10px", width: "calc(100% - 124px)" }} onClick={()=>this.toggleEditingStepTitle()}>
                        <LightTooltip title={title} aria-label={title} placement="top" enterDelay={500} enterNextDelay={500}>
                            <div style={{ width: "calc(100% - 124px)!important", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {this.highlighter(title.toString())}
                                {/*{title.toString()}*/}
                            </div>
                        </LightTooltip>
                    </h3>}

                {this.state.selectedStepDivID == divID && !this.state.editingStepTitle && !this.props.isLiteView ? <div style={{ width: "85px", display: "flex", flexDirection: "row", marginRight: "10px" }}>
                    <div className="" id="" onClick={(e) => this.toggleContentForm(e)} style={{ textAlign: "center", height: "30px", width: "30px", marginTop: "auto", marginBottom: "auto", background: "transparent", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <LightTooltip title="Edit Content" aria-label="Edit Content" placement="top" enterDelay={500} enterNextDelay={500}>
                            <div style={{ 
                                width: "15px", 
                                height: "28px", 
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center",
                                fontSize: "16px"
                            }}>
                                <FontAwesomeIcon icon={faPenToSquare} />
                            </div>
                        </LightTooltip>
                    </div>
                    <div className="stepButton" style={{ height: "30px", width: "30px", background: "transparent", marginTop: "auto", marginBottom: "auto" }}>
                        {addAttachmentIcon(1, this.toggleAttachments, "Open Attachment Library", false, true)}
                    </div>
                    {/* <div className="stepButton" style={{ height: "30px", width: "30px", background: "transparent", marginTop: "auto", marginBottom: "auto" }}>
                        {countStepAlerts(1, this.updateEditingStepAlerts, true, false)}
                    </div> */}
                </div> : null}
                {this.props.isLiteView ? <DoneButton key={`done-${step._id}`} stepId={step._id} list={this.state.doneStepList} updateDoneStepStateList={this.updateDoneStepStateList} /> : null}
            </div>
            <div className="step-display-div-body">
                {this.state.editingStepAlerts && this.state.selectedStepDivID == divID ?
                    <StepAlerts
                        infoPage={this.state.infoPage}
                        selectedStep={this.state.selectedStep ? this.state.selectedStep : undefined}
                        updateInfoPage={this.updateInfoPage}
                        getInfoPage={this.getInfoPage}
                    />
                    : <StepContent
                        addWILink={this.addWILink}
                        annotationHasBeenCreatedPre={this.state.annotationHasBeenCreatedPre}
                        attachments={this.state.selectedStep ? this.state.selectedStep.attachments : []}
                        attachmentIndex={this.state.attachmentIndex}
                        clickOnAnnotation={this.clickOnAnnotation}
                        closeOutContentEditor={this.closeOutContentEditor}
                        currentCameraPlacement={this.state.currentCameraPlacement}
                        currentStepAttachmentModel={this.state.currentStepAttachmentModel}
                        deleteWILink={this.deleteWILink}
                        divStepParent={divID}
                        editingContent={this.state.editingContent}
                        editingStepTitle={this.state.editingStepTitle}
                        editStepTitle={() => this.setState({ editingStepTitle: true })}
                        finishEditing={() => this.setState({ editingContent: false })}
                        finishStepTitleEdit={() => this.setState({ editingStepTitle: false, editingContent: true })}
                        getAddedAnnotation={this.getAddedAnnotation}
                        getAttachmentIndex={this.getAttachmentIndex}
                        getAnnotationHasBeenCreatedPre={this.getAnnotationHasBeenCreatedPre}
                        getCurrentStepAttachmentModel={this.getCurrentStepAttachmentModel}
                        getSelectedAnnotation={this.getSelectedAnnotation}
                        getTextSelectedInEditor={this.getTextSelectedInEditor}
                        isAttachmentModel={this.isAttachmentModel}
                        // highlighter ={this.highlighter}
                        modelsLoaded={this.state.modelsLoaded}
                        removeAnnotationFromScreen={this.removeAnnotationFromScreen}
                        saveNewAnnotation={this.saveNewAnnotation}
                        selectedAnnotation={this.state.selectedAnnotation}
                        selectedStep={step}
                        selectedStepDivID={this.state.selectedStepDivID}
                        selectedStepIsChild={this.state.selectedStepIsChild}
                        stepSearch={this.state.searchString}
                        textSelectedInEditor={this.state.textSelectedInEditor}
                        textSelectionRange={this.state.textSelectionRange}
                        toggleAnnotation={this.state.toggleAnnotation}
                        toggleContentForm={this.toggleContentForm}
                        toggleTextSelectedInEditor={this.toggleTextSelectedInEditor}
                        unityContextRef={this.state.unityContextRef}
                        updateEditorRef={this.updateEditorRef}
                        updateStep={this.updateStep}
                        updateSteps={this.updateSteps}
                        updateSelectedStep={this.updateSelectedStep}
                        showAnnotationJS={this.showAnnotationJS}
                        isLiteView={this.props.isLiteView}
                    />}
            </div>
        </div></li>
    }
    // -------------------------------------------------------------- Analyzes a step and its child steps, creating a display of the steps. --------------------------------------------------------------//

    // -------------------------------------------------------------- Creates a display of steps for rendering. --------------------------------------------------------------//

    createStepsDisplay = () => {
        console.log(`[WI ${this.props.wip_ID}] createStepsDisplay called`, {
            activeElement: document.activeElement?.id,
            searchString: this.state.searchString
        });
        console.log(`[WI ${this.props.wip_ID}] Current editingContent state:`, this.state.editingContent);
        const flattenedSteps = [];
        this.state.steps.forEach((step, index) => {
            const stepNumber = `${index + 1}`;
            this.flattenStepTree(step, stepNumber, flattenedSteps);
        });

        const normalizedSearch = (this.state.searchString || "").trim().toLowerCase();
        const filteredSteps = normalizedSearch
            ? flattenedSteps.filter(({ step, stepNum }) =>
                this.stepMatchesSearch(step, normalizedSearch) || stepNum.toLowerCase().includes(normalizedSearch)
            )
            : flattenedSteps;

        const pathLinks = [];
        const display = [];

        filteredSteps.forEach(({ step, stepNum }) => {
            const stepDiv = this.createStepDiv(step, stepNum, pathLinks);
            if (stepDiv != null) {
                display.push(stepDiv);
            }
        });

        if (normalizedSearch && display.length === 0) {
            display.push(
                <li key="no-step-results">
                    <div className="step-display-div shadow" style={{ padding: '1rem' }}>
                        <p>No steps match "{this.state.searchString}".</p>
                    </div>
                </li>
            );
        }

        const newCombinedTitle = flattenedSteps.map(({ step, stepNum }) => {
            const stepTitle = step.title && step.title.length > 0 ? step.title : stepNum.toString();
            return `${stepNum} - ${stepTitle}`;
        });

        let selectedContainer = document.getElementsByClassName("selected-container")
        if (selectedContainer.length > 0 && !this.state.firstLoaded) {
            selectedContainer[0].click()
        }

        console.log(`[WI ${this.props.wip_ID}] createStepsDisplay setting state, display length: ${display.length}`);
        this.setState({ stepsDisplay: display, firstLoaded: true, combinedTitle: newCombinedTitle }, () => {
            console.log(`[WI ${this.props.wip_ID}] createStepsDisplay state updated, checking active element:`, document.activeElement?.id);
        })

        return <div style={{ width: '100%', height: "100%", overflowY: "hidden", overflowX: "hidden", display: "flex", flexDirection: "column" }}>
            <div style={{ flexShrink: 0, marginRight: '1em' }}>
                {this.renderStepSearchAndTOCToggle()}
            </div>
            <div id="step-Div-Parent" style={{ width: '100%', flex: 1, overflowY: "auto", overflowX: "hidden", minHeight: 0 }}>
                <ul>{display}</ul>
            </div>
        </div>
    }
    // -------------------------------------------------------------- Toggles the visibility of the Table of Contents (TOC). --------------------------------------------------------------//

    toggleTOC = () => {
        // Ensure TOC can only be toggled if not in Lite View
        if (!this.props.isLiteView) {
            this.setState(({ showTOC }) => ({ showTOC: !showTOC }));
        }
    }
    // -------------------------------------------------------------- Toggles the annotation panel. --------------------------------------------------------------//

    toggleAnnotation = (e) => {
        e.stopPropagation();
        let toggleAnnotation = this.state.toggleAnnotation
        this.setState({ toggleAnnotation: !toggleAnnotation, editingStepAlerts: false, editingContent: false }, () => this.createStepsDisplay());
    }
    // -------------------------------------------------------------- Changes the first step div to the selected step. --------------------------------------------------------------//

    clickFirstStepDiv = (display) => {
        let id = display[0].props.children.props.id
        let el = document.getElementById(id)
        if (checkNotUndefindeNull(el)) {
            el.click();
        }
    }
    // -------------------------------------------------------------- Opens wi link modal selection. --------------------------------------------------------------//

    setWILinkModal = (modalState) => {
        this.setState({ addingPDFPageWILink: modalState },()=>{
            this.renderModal();
            if(!this.state.addingPDFPageWILink){
                this.setState({modalToDisplay: null})
            }
        })
    }
    // -------------------------------------------------------------- Handles changes in the search input for step divs. --------------------------------------------------------------//

    stepDivSearchChange = (e) => {
        const searchString = e.target.value;
        if (searchString === this.state.searchString) {
            return;
        }
        const inputId = e.target.id;
        const cursorPos = e.target.selectionStart || 0;
        
        console.log(`[WI ${this.props.wip_ID}] stepDivSearchChange: "${searchString}"`, {
            activeElement: document.activeElement?.id,
            inputElement: inputId,
            cursorPos: cursorPos
        });
        
        // Store the input element reference BEFORE state update
        const inputElement = e.target;
        
        // Update searchString state and immediately recalculate stepsDisplay
        // This avoids nested setState calls
        const flattenedSteps = [];
        this.state.steps.forEach((step, index) => {
            const stepNumber = `${index + 1}`;
            this.flattenStepTree(step, stepNumber, flattenedSteps);
        });

        const normalizedSearch = (searchString || "").trim().toLowerCase();
        const filteredSteps = normalizedSearch
            ? flattenedSteps.filter(({ step, stepNum }) =>
                this.stepMatchesSearch(step, normalizedSearch) || stepNum.toLowerCase().includes(normalizedSearch)
            )
            : flattenedSteps;

        const pathLinks = [];
        const display = [];

        filteredSteps.forEach(({ step, stepNum }) => {
            const stepDiv = this.createStepDiv(step, stepNum, pathLinks);
            if (stepDiv != null) {
                display.push(stepDiv);
            }
        });

        if (normalizedSearch && display.length === 0) {
            display.push(
                <li key="no-step-results">
                    <div className="step-display-div shadow" style={{ padding: '1rem' }}>
                        <p>No steps match "{searchString}".</p>
                    </div>
                </li>
            );
        }

        const newCombinedTitle = flattenedSteps.map(({ step, stepNum }) => {
            const stepTitle = step.title && step.title.length > 0 ? step.title : stepNum.toString();
            return `${stepNum} - ${stepTitle}`;
        });
        
        // Update both states in a single setState call to avoid multiple renders
        this.setState({ 
            searchString,
            stepsDisplay: display,
            combinedTitle: newCombinedTitle
        }, () => {
            console.log(`[WI ${this.props.wip_ID}] State updated, checking active element:`, document.activeElement?.id);
            
            // Don't call updateContentSpan here - let componentDidUpdate handle it to avoid timing issues
            // The componentDidUpdate will handle attaching event listeners after DOM is ready
            
            // Restore focus AFTER render completes - use triple RAF to ensure it's after componentDidUpdate and all setTimeout callbacks
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        const restoredInput = this.searchInputRef.current || document.getElementById(inputId);
                        if (restoredInput) {
                            const isFocused = document.activeElement === restoredInput || document.activeElement?.id === inputId;
                            console.log(`[WI ${this.props.wip_ID}] Focus check (after triple RAF) - currently focused: ${isFocused}, activeElement:`, document.activeElement?.id);
                            if (!isFocused) {
                                console.log(`[WI ${this.props.wip_ID}] Restoring focus to input: ${inputId}`);
                                restoredInput.focus();
                                // Restore cursor position - use the stored cursorPos from before state update
                                if (restoredInput.setSelectionRange) {
                                    const newCursorPos = Math.min(cursorPos + 1, restoredInput.value.length); // +1 because we just typed a character
                                    restoredInput.setSelectionRange(newCursorPos, newCursorPos);
                                    console.log(`[WI ${this.props.wip_ID}] Cursor restored to position: ${newCursorPos}`);
                                }
                            }
                        } else {
                            console.warn(`[WI ${this.props.wip_ID}] Input element not found: ${inputId}`);
                        }
                    });
                });
            });
        });
    }
    // -------------------------------------------------------------- Highlights text based on a search string. --------------------------------------------------------------//

    renderStepSearchAndTOCToggle = () => {
        const showToggle = !this.props.isLiteView;

        return <div style={{ 
            height: "50px", 
            width: "100%", 
            display: "flex", 
            flexDirection: "row", 
            alignItems: "center", 
            gap: "8px",
            padding: "0 8px"
        }}>
            {showToggle && (
                <div style={{ 
                    width: "40px", 
                    flexShrink: 0,
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    cursor: "pointer" 
                }}>
                    {tocToggleIcon(this.toggleTOC, this.state.showTOC, false)}
                </div>
            )}
            <div style={{ 
                display: "flex", 
                flex: 1, 
                minWidth: 0,
                position: "relative",
                alignItems: "center"
            }}>
                <style>{`
                    #stepDivSearch_${this.props.wip_ID}::placeholder {
                        color: rgba(4, 0, 0, 0.26);
                        font-family: var(--sds-typography-body-font-family);
                        font-size: var(--sds-typography-body-size-medium);
                        font-style: normal;
                        font-weight: var(--sds-typography-body-font-weight-regular);
                        line-height: 100%;
                    }
                `}</style>
                <input
                    key={`search-input-${this.props.wip_ID}`}
                    ref={this.searchInputRef}
                    style={{
                        width: "100%",
                        height: "40px",
                        padding: "8px 40px 8px 16px",
                        border: "1px solid #ccc",
                        borderRadius: "20px",
                        outline: "none",
                        fontSize: "var(--sds-typography-body-size-medium, 14px)",
                        fontFamily: "var(--sds-typography-body-font-family)",
                        fontWeight: "var(--sds-typography-body-font-weight-regular)",
                        lineHeight: "100%",
                        boxSizing: "border-box",
                        background: "#fff",
                        color: "#000"
                    }}
                    type="text"
                    placeholder='Search'
                    id={`stepDivSearch_${this.props.wip_ID}`}
                    onChange={e => this.stepDivSearchChange(e)}
                    onBlur={(e) => {
                        // Persist the event to prevent React from nullifying it
                        e.persist();
                        // Store target reference immediately before async operations
                        const inputElement = e.target;
                        const searchString = this.state.searchString;
                        
                        // Check where focus actually went after a short delay
                        // This handles both click events (which may not set relatedTarget) and re-renders
                        setTimeout(() => {
                            const newActiveElement = document.activeElement;
                            const input = this.searchInputRef.current || document.getElementById(`stepDivSearch_${this.props.wip_ID}`) || inputElement;
                            
                            // Check if focus moved to another input/textarea/select/button or contenteditable
                            const isBlurringToAnotherInput = newActiveElement?.tagName === 'INPUT' || 
                                                             newActiveElement?.tagName === 'TEXTAREA' ||
                                                             newActiveElement?.tagName === 'SELECT' ||
                                                             newActiveElement?.tagName === 'BUTTON' ||
                                                             newActiveElement?.contentEditable === 'true' ||
                                                             newActiveElement?.getAttribute('contenteditable') === 'true' ||
                                                             newActiveElement?.tagName === 'IFRAME' ||
                                                             newActiveElement?.closest('iframe') !== null;
                            
                            // Check if focus is inside an editor container (TinyMCE, contenteditable divs, etc)
                            const editorContainers = document.querySelectorAll('[id*="editor"], [id*="Editor"], [class*="editor"], [class*="Editor"], #step-content, #step-content-container, .tox-tinymce');
                            const isInsideEditor = Array.from(editorContainers).some(container => {
                                return container.contains(newActiveElement) || container === newActiveElement;
                            });
                            
                            // Only restore focus if:
                            // 1. Focus didn't go to another input/textarea/etc
                            // 2. Focus is not inside an editor container
                            // 3. This input is not currently focused
                            // 4. The input still exists in the DOM
                            if (!isBlurringToAnotherInput && !isInsideEditor && input && document.activeElement !== input) {
                                // Check if user clicked on a clickable element (like buttons, links, etc)
                                const clickedElement = document.activeElement;
                                const isClickableElement = clickedElement?.onclick !== null || 
                                                          clickedElement?.getAttribute('role') === 'button' ||
                                                          clickedElement?.classList.contains('clickable') ||
                                                          clickedElement?.closest('button') !== null ||
                                                          clickedElement?.closest('a') !== null;
                                
                                // Don't restore if user clicked on a clickable element
                                if (!isClickableElement) {
                                    console.log(`[WI ${this.props.wip_ID}] Input blur event - restoring focus`);
                                    input.focus();
                                    // Restore cursor position if there's text
                                    if (input.setSelectionRange && searchString) {
                                        const cursorPos = Math.min(searchString.length, input.value.length);
                                        input.setSelectionRange(cursorPos, cursorPos);
                                    }
                                }
                            }
                        }, 50); // Small delay to let click events complete
                    }}
                    value={this.state.searchString}
                    aria-label="Search steps"
                    autoComplete="off"
                />
                {this.state.searchString && (
                    <button
                        onClick={() => this.setState({ searchString: "" }, () => this.createStepsDisplay())}
                        style={{
                            position: "absolute",
                            right: "12px",
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "20px",
                            height: "20px",
                            fontSize: "18px",
                            lineHeight: "1",
                            color: "#1E1E1E"
                        }}
                        aria-label="Clear search"
                    >
                        ×
                    </button>
                )}
            </div>
        </div>
    }
    // -------------------------------------------------------------- Sets the attachment index and checks if the attachment is a model. --------------------------------------------------------------//

    setAttachmentIndex = (value) => {
        let isModel = this.isAttachmentModel(null, value);
        this.setState({ attachmentIndex: value, currentStepAttachmentModel: isModel }, () => this.createAnnotationArray())
    }
    // -------------------------------------------------------------- Retrieves camera information from the Unity context. --------------------------------------------------------------//

    getCameraInfo = () => {
        if (checkNotUndefindeNull(this.state.unityContextRef)) {
            this.state.unityContextRef.send("Manager", "OutputCameraPositionData")
        }
    }

    render = () => {
        let attachments = this.state.currentAttachments
        if (this.state.isPDFViewer === 0) {
            attachments = []
        }
        return <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* {this.renderModal()} */}
            {this.state.modalToDisplay}
            <div id="success-banner" className="flex-centered fade-in-and-out max-width"
                style={{ 
                    display: `${this.state.confirmationMessage.length > 0 ? "flex" : "none"}`,
                    position: 'absolute',
                    top: '10px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1000
                }}
                onClick={()=>this.closeConfirmation()}>
                <p>{this.state.confirmationMessage}</p>
            </div>
            {/* Editing Warning Modal */}
            {this.state.showEditingWarningModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        maxWidth: '500px',
                        width: '90%',
                        textAlign: 'center'
                    }}>

                        <h3 style={{
                            color: '#333',
                            marginBottom: '15px',
                            fontSize: '20px'
                        }}>
                            Work Instruction In Use
                        </h3>
                        <p style={{
                            color: '#666',
                            marginBottom: '25px',
                            lineHeight: '1.5',
                            fontSize: '16px'
                        }}>
                            {this.state.editingWarningMessage}
                        </p>
                        <div style={{
                            display: 'flex',
                            gap: '15px',
                            justifyContent: 'center'
                        }}>
                            <button
                                onClick={this.handleReturnToList}
                                style={{
                                    backgroundColor: '#95a5a6',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 24px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#7f8c8d'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#95a5a6'}
                            >
                                Return to List
                            </button>
                            <button
                                onClick={this.handleContinueEditing}
                                style={{
                                    backgroundColor: '#081f5f',
                                    color: 'white',
                                    border: 'none',
                                    padding: '12px 24px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: 'bold'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#0a2463'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#081f5f'}
                            >
                                Continue Anyway
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div className="flex" style={{ flex: '1 1 auto', minHeight: 0, height: '100%' }}>
                <div id="LeftRightAuthorContainer">
                    <div id="wi-author-right" className="flex-row max-size">
                        <div id="attachments-display-container" className="flex-column max-width">
                            {attachments.length > 0 ?
                                <AttachmentRenderer
                                    attachments={this.state.currentAttachments}
                                    setAttachmentIndex={(value) => this.setAttachmentIndex(value)}
                                    attachmentIndex={this.state.attachmentIndex}
                                    updateColor={this.storeColor}
                                    WIPID={this.state.workInstruction._id}
                                    storeCameraData={this.storeCameraData}
                                    openAttachments={() => this.setState({ showingAttachments: true },()=>this.renderModal())}
                                    updateCurrentCameraPlacement={this.updateCurrentCameraPlacement}
                                    toggleAnnotation={this.state.toggleAnnotation}
                                    unityContextRef={this.state.unityContextRef}
                                    updateUnityContext={this.updateUnityContext}
                                    callFromAuthor={true}
                                    textSelectedInEditorFlag={this.state.textSelectedInEditorFlag}
                                    textSelectedInEditor={this.state.textSelectedInEditor}
                                    isPDFViewer={this.state.isPDFViewer}
                                    currentlySelectedPDFAnnotationID={this.state.currentlySelectedPDFAnnotationID}
                                    libraryOpen={this.state.showingAttachments}
                                    addAnnotation={this.addAnnotation}
                                    onModelsLoaded={this.handleModelsLoaded}
                                />
                                :
                                <Directions openAttachments={this.props.openAttachments} />}
                        </div>
                    </div>
                    <div id="wi-author-left" style={{ borderRadius: "0" }} className="flex max-height">
                        {this.state.isPDFViewer ?
                            <div style={{ width: "100%", overflow: "hidden" }}>
                                <Toolbar
                                    WITitle={this.state.title}
                                    toggleEditTags={this.toggleEditTags}
                                    isPDFWip={true}
                                    currentWorkInstructionTags={cloneDeep(this.props.workInstruction.tags)}
                                    isSavable={this.state.isSavable}
                                    saveWorkInstruction={this.saveWorkInstruction}
                                    previewWorkInstruction={this.previewWorkInstruction}
                                    editPublicationPage={this.editPublicationPage}
                                    isReleased={this.state.isReleased}
                                    toggleAllAlertsPage={this.toggleAllAlertsPage}
                                    toggleRelease={this.toggleRelease}
                                    togglePublicationPage={this.togglePublicationPage}
                                />

                                <PDFDisplay
                                    setSelectedText={this.setSelectedText}
                                    setPdfViewerInstance={this.setPdfViewerInstance}
                                    textToSearch={this.state.textToSearch}
                                    currentPDF={this.state.currentPDF}
                                    setMappingAnnotations={this.setMappingAnnotations}
                                    getCameraInfo={this.getCameraInfo}
                                    unityContextRef={this.state.unityContextRef}
                                    addNewHighlightAnnotation={this.addNewHighlightAnnotation}
                                    PDFViewerHighlights={this.state.PDFViewerHighlights}
                                    deletePDFAnnotation={this.deletePDFAnnotation}
                                    toggleAttachments={this.toggleAttachments}
                                    setSelectedAnnotation={this.setIsRedrawTrue}
                                    updateAnnoList={this.updateAnnoList}
                                    isRedraw={this.returnIsRedraw}
                                    deleteSingleAnnotation={this.deleteSingleAnnotation}
                                    setWILinkModal={this.setWILinkModal}
                                    openNewTab={this.props.addTab}
                                />

                            </div>

                            :
                            <Fragment>
                                {/* Adjust container class based on isLiteView and showTOC state */}
                                <div id={`${this.props.isLiteView || !this.state.showTOC ? 'steps-display-container-full' : 'steps-display-container-half'}`} className={`steps-container ${this.state.showTOC && !this.props.isLiteView ? 'steps-with-toc' : 'steps-no-toc'}`}>
                                    <div style={{ width: '100%', height: "100%", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                                        <div style={{ flexShrink: 0, marginRight: '.5em' }}>
                                            {this.renderStepSearchAndTOCToggle()}
                                        </div>
                                        <div id="step-Div-Parent" style={{ width: '100%', flex: 1, overflowY: "auto", overflowX: "hidden", minHeight: 0 }}>
                                            <ul>{this.state.stepsDisplay}</ul>
                                        </div>
                                    </div>
                                </div>
                                {/* ---------------------------------------------------------------- DISPLAYS STEP TREE (RIGHT SIDE) ---------------------------------------------------------------- */}

                                {/* Always render TOC container but control visibility with CSS for smooth animation */}
                                {this.state.loaded && !this.props.isLiteView ?
                                    <div className={`toc-container ${this.state.showTOC ? 'toc-visible' : 'toc-hidden'}`}>
                                        <TableOfContents
                                            getSteps={() => { return this.state.steps }}
                                            getPath={() => { return this.state.path }}
                                            WIPID={this.props.wip_ID}
                                            steps={this.state.steps}
                                            stepDeleted={()=>this.stepDeleted()}
                                            selectStep={this.selectStep}
                                            editTitle={() => this.setState({ editingStepTitle: true })}
                                            toggleAllAlertsPage={this.toggleAllAlertsPage}
                                            selectedStepId={this.state.selectedStep ? this.state.selectedStep._id : 0}
                                            tree={this.state.tree}
                                            path={this.state.path}
                                            selectedStep={this.state.selectedStep}
                                            beforeAddStep={this.beforeAddStep}
                                            addStep={this.addStep}
                                            updateTree={this.updateTree}
                                            updateSteps={this.updateSteps}
                                            UpdateStepNodePath={(list) => this.setState({ stepNodePath: list })}
                                            combinedTitle={this.state.combinedTitle}
                                            toolbar={
                                                <Toolbar
                                                    WITitle={this.state.title}
                                                toggleEditTags={this.toggleEditTags}
                                                // toggleAutoSave={this.toggleAutoSave}
                                                // hasAutoSave={this.state.hasAutoSave}
                                                isPDFWip={false}
                                                currentWorkInstructionTags={cloneDeep(this.props.workInstruction.tags)}
                                                // submitTitleEdit={(title) => this.setState({ title, isSavable: true })}
                                                isSavable={this.state.isSavable}
                                                saveWorkInstruction={(e) => this.saveWorkInstruction(false, this.state.isReleased, null, null)} // Pass standard save params
                                                previewWorkInstruction={this.previewWorkInstruction}
                                                editPublicationPage={this.editPublicationPage}
                                                isReleased={this.state.isReleased}
                                                toggleAllAlertsPage={this.toggleAllAlertsPage}
                                                toggleRelease={this.toggleRelease} // Keep this for direct release toggle if needed elsewhere
                                                togglePublicationPage={this.togglePublicationPage} // Keep this to open/close the modal
                                            />}
                                        />
                                    </div>
                                    : null
                                }
                            </Fragment>}
                    </div>

                </div>
            </div>
        </div>
    }

    // Ensure any in-progress editor changes are saved before structural mutations (add step/substep)
    beforeAddStep = () => {
        if (this.state.editingContent && this.state.isSavable) {
            this.saveWorkInstruction();
        }
    }

    // Helper function to recursively find and update a step's title in the tree
    updateStepTitleInTree = (steps, targetId, newTitle) => {
        // Use map to create a new array to avoid direct state mutation
        return steps.map(step => {
            // If this is the step we're looking for, update its title
            if (step._id === targetId) {
                // Return a new object with the updated title
                return { ...step, title: newTitle };
            }
            // If this step has children, recursively update them
            if (step.children && step.children.length > 0) {
                 // Return a new object with updated children
                return { ...step, children: this.updateStepTitleInTree(step.children, targetId, newTitle) };
            }
            // Otherwise, return the step unchanged
            return step;
        });
    }

    // -------------------------------------------------------------- Handles texture save events and refreshes WI data --------------------------------------------------------------//
    
    handleTexturesSaved = async () => {
        console.log('Textures were saved, refreshing work instruction data...');
        try {
            const res = await fetchWorkInstruction(this.props.wip_ID);
            const wi = cloneDeep(res.data);
            
            // Find the currently selected step in the refreshed data
            const refreshedSelectedStep = wi.steps.find(step => step._id === this.state.selectedStep._id);
            
            // Update current attachments with the refreshed data
            let refreshedCurrentAttachments = [];
            if (refreshedSelectedStep && !this.state.isPDFViewer) {
                refreshedCurrentAttachments = refreshedSelectedStep.attachments || [];
            } else if (this.state.isPDFViewer) {
                refreshedCurrentAttachments = [];
            }
            
            // Update the work instruction state with fresh data from the server
            // This ensures we have the latest texture_config data for all attachments
            this.setState({
                workInstruction: wi,
                steps: wi.steps,
                selectedStep: refreshedSelectedStep || this.state.selectedStep,
                currentAttachments: refreshedCurrentAttachments
            }, () => {
                // Trigger a re-render of the annotation array
                this.createAnnotationArray();
            });
            
            console.log('Work instruction data refreshed successfully');
        } catch (error) {
            console.error('Error refreshing work instruction data:', error);
        }
    }

    // --------- New: load progress from Electron backend ---------
    loadProgress = async () => {
        try {
            const isElectron = typeof window !== 'undefined' && !!window.electronAPI;
            if (!isElectron) {
                // Skip local progress in web context to avoid overriding assignment-based state
                return;
            }
            const base = window.config ? window.config.getApiBaseUrl() : '';
            if (!base) return;
            const res = await fetch(`${base}/api/stepsProgress/${this.props.wip_ID}`);
            const data = await res.json();
            let list = Array.isArray(data) && data.length > 0 ? data : this.createDoneStepStateList(this.state.steps);
            this.setState({ doneStepList: list }, ()=> this.createStepsDisplay());
        } catch (e) {
            console.error('[WIAuthorSteps] Failed to load local step progress:', e);
            // Only fallback to defaults in Electron; in web, preserve backend-derived state
            const isElectron = typeof window !== 'undefined' && !!window.electronAPI;
            if (isElectron) {
                const list = this.createDoneStepStateList(this.state.steps);
                this.setState({ doneStepList: list });
            }
        }
    }
}

export default withRouter(WIAuthorSteps)